webpackJsonp([0],{

/***/ "+ZNz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/buyu_m_game.b2dab1d.mp4";

/***/ }),

/***/ "+b8s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.40bead1.jpg";

/***/ }),

/***/ "+k7N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhuajimajiang.bd747f3.jpg";

/***/ }),

/***/ "+oo4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.8b348b5.jpg";

/***/ }),

/***/ "/NOx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.05fa3ea.jpg";

/***/ }),

/***/ "0Dms":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_small_1027.0dd7fde.png";

/***/ }),

/***/ "1F9U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pirateFishing.1a7d253.png";

/***/ }),

/***/ "1VxO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1uPM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kawufumajiang.a010c4d.jpg";

/***/ }),

/***/ "1vqm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hangzhoumajiang.526f93e.jpg";

/***/ }),

/***/ "2Jms":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.0e1860d.jpg";

/***/ }),

/***/ "3SGe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shaibao.46a8f92.jpg";

/***/ }),

/***/ "3SJ+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hqR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhajinhua_pc_game.075bac8.mp4";

/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3uMc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.4422e71.jpg";

/***/ }),

/***/ "474U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fuzhoumajiang.4af46ba.jpg";

/***/ }),

/***/ "4Fbv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/benchibaoma.bbfa95f.jpg";

/***/ }),

/***/ "4bXQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/JinhaiPoker.fe795dc.jpg";

/***/ }),

/***/ "4m/A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.7cacde5.jpg";

/***/ }),

/***/ "4pSx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.f152c4a.jpg";

/***/ }),

/***/ "5/6a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1050.3efb648.png";

/***/ }),

/***/ "5Ogl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.6c038ee.jpg";

/***/ }),

/***/ "5U0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5evJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1404.016f48a.png";

/***/ }),

/***/ "6Erz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6OjC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qiangzhuangtuitongzi.8b5ce38.jpg";

/***/ }),

/***/ "6WAn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6bm5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1404.9312ff7.png";

/***/ }),

/***/ "7tfa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/niuniu_m_game.a666240.mp4";

/***/ }),

/***/ "8MA0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.fa8563d.jpg";

/***/ }),

/***/ "8R+o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhongyongmajiang.0bfe4f2.jpg";

/***/ }),

/***/ "8kkO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/senlinwuhui.6481503.jpg";

/***/ }),

/***/ "8vzP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "91nV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/19.0b96706.jpg";

/***/ }),

/***/ "9dt9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dongbeimajiang.9be3d7b.jpg";

/***/ }),

/***/ "9sIl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wangzhezuqiu.5c6bd2b.jpg";

/***/ }),

/***/ "9vEd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9zhb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/17.798c851.jpg";

/***/ }),

/***/ "AOxs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/niuniu_pc_game.90ec4f3.mp4";

/***/ }),

/***/ "Abqo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qznn_3d_banner.f1eb2d9.png";

/***/ }),

/***/ "Al4e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.17f7d82.jpg";

/***/ }),

/***/ "BU3T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11.07bf4ec.jpg";

/***/ }),

/***/ "BUTA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.7d1d53d.jpg";

/***/ }),

/***/ "BWXV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HUNDREDS_Niu-niu.85bbc1f.jpg";

/***/ }),

/***/ "BeLy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ksznn_3d_banner.2b60c3d.png";

/***/ }),

/***/ "Bf+Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BfMz":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/12.be08efb.jpg";

/***/ }),

/***/ "C//j":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xueliumajiang.f49a3e4.jpg";

/***/ }),

/***/ "D13e":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.dbbbb74.jpg";

/***/ }),

/***/ "DHzu":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "Egis":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/28.fd7fb6d.jpg";

/***/ }),

/***/ "EyRZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/errenmj_banner.cfa8fda.png";

/***/ }),

/***/ "GGvJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qiangzhuangpaijiu.fa8563d.jpg";

/***/ }),

/***/ "GZ8D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/26.9af7a1e.jpg";

/***/ }),

/***/ "Gej+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fanbeimajiang.f5b6381.png";

/***/ }),

/***/ "I+wM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1050.1330d4b.png";

/***/ }),

/***/ "Id51":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/29.c79eb0b.png";

/***/ }),

/***/ "JYLN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KU8+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KcI4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.e142dbb.jpg";

/***/ }),

/***/ "Kdb+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/baijiale_m_game.3fd407f.mp4";

/***/ }),

/***/ "KhNL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LDsI":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "MC4m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MIBB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doudizhu2.9e6c88d.jpg";

/***/ }),

/***/ "MLVY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/9.b21ba95.jpg";

/***/ }),

/***/ "MfcT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/23.566f234.jpg";

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex-i18n/dist/vuex-i18n.es.js
var vuex_i18n_es = __webpack_require__("kmDT");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Thumbnail/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Thumbnail = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  methods: {
    handleVideo: function handleVideo(index) {
      this.$emit("modalClick", true, index);
    },
    bannerChange: function bannerChange() {
      var _this = this;

      var index = this.aIndex;
      this.bannerImgList = [];
      this.$nextTick(function () {
        _this.bannerImgList = _this.bannerList;
        _this.$nextTick(function () {
          _this.$refs.swiperTop.swiper.slideTo(index, 100);
          _this.$refs.swiperTop.swiper.update(true);
        });
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  watch: {
    // isMobile(v) {
    //   this.bannerChange();
    // },
    lang: function lang(v) {
      this.bannerChange();
    }
  },
  mounted: function mounted() {
    this.bannerChange();
  },
  updated: function updated() {
    // this.bannerChange();
  },
  data: function data() {
    return {
      aIndex: 1,
      changeDir: "image",
      bannerImgList: [],
      bannerList: [{
        picUrl: __webpack_require__("yF/s"),
        title: "banner.baijiale",
        smallTitle: "bannerSmallTitle.baijiale",
        flag: 0
      }, {
        picUrl: __webpack_require__("Z1XC"),
        title: "banner.lunpan",
        smallTitle: "bannerSmallTitle.lunpan",
        flag: 0
      }, {
        picUrl: __webpack_require__("+oo4"),
        title: "banner.buyu",
        smallTitle: "bannerSmallTitle.buyu",
        flag: 0
      }, {
        picUrl: __webpack_require__("2Jms"),
        title: "banner.zhanjinhua",
        smallTitle: "bannerSmallTitle.zhanjinhua",
        flag: 0
      }, {
        picUrl: __webpack_require__("dVNw"),
        title: "banner.niuniu",
        smallTitle: "bannerSmallTitle.niuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("KcI4"),
        title: "banner.tuiTongzi",
        smallTitle: "bannerSmallTitle.tuiTongzi",
        flag: 0
      }, {
        picUrl: __webpack_require__("zYMp"),
        title: "banner.longhu",
        smallTitle: "bannerSmallTitle.longhu",
        flag: 0
      }, {
        picUrl: __webpack_require__("XLW9"),
        title: "banner.dezhou",
        smallTitle: "bannerSmallTitle.dezhou",
        flag: 0
      }, {
        picUrl: __webpack_require__("/NOx"),
        title: "banner.jisuhua",
        smallTitle: "bannerSmallTitle.jisuhua",
        flag: 0
      }, {
        picUrl: __webpack_require__("+b8s"),
        title: "banner.shisanshui",
        smallTitle: "bannerSmallTitle.shisanshui",
        flag: 0
      }, {
        picUrl: __webpack_require__("BfMz"),
        title: "banner.paijiu",
        smallTitle: "bannerSmallTitle.paijiu",
        flag: 0
      }, {
        picUrl: __webpack_require__("jylW"),
        title: "banner.kingOfFishing3D",
        smallTitle: "bannerSmallTitle.kingOfFishing3D",
        flag: 0
      }, {
        picUrl: __webpack_require__("evfb"),
        title: "banner.ershiyidian",
        smallTitle: "bannerSmallTitle.ershiyidian",
        flag: 0
      }, {
        picUrl: __webpack_require__("9zhb"),
        title: "banner.bairenbaijiale",
        smallTitle: "bannerSmallTitle.bairenbaijiale",
        flag: 0
      }, {
        picUrl: __webpack_require__("upOt"),
        title: "banner.honghei",
        smallTitle: "bannerSmallTitle.honghei",
        flag: 0
      }, {
        picUrl: __webpack_require__("Z8hn"),
        title: "banner.shidianban",
        smallTitle: "bannerSmallTitle.shidianban",
        flag: 0
      }, {
        picUrl: __webpack_require__("91nV"),
        title: "banner.niuniu4",
        smallTitle: "bannerSmallTitle.niuniu4",
        flag: 0
      }, {
        picUrl: __webpack_require__("YYzr"),
        title: "banner.bairenniuniu",
        smallTitle: "bannerSmallTitle.bairenniuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("oMHB"),
        title: "banner.majiangxueliu",
        smallTitle: "bannerSmallTitle.majiangxueliu",
        flag: 0
      }, {
        picUrl: __webpack_require__("MfcT"),
        title: "banner.benzAndBMW",
        smallTitle: "bannerSmallTitle.benzAndBMW",
        flag: 0
      }, {
        picUrl: __webpack_require__("Id51"),
        title: "banner.fanbeimajiang",
        smallTitle: "bannerSmallTitle.fanbeimajiang",
        flag: 0
      }, {
        picUrl: __webpack_require__("1F9U"),
        title: "banner.pirateFishing",
        smallTitle: "bannerSmallTitle.pirateFishing",
        flag: 0
      }, {
        picUrl: __webpack_require__("whnJ"),
        title: "banner.mermaidFishing",
        smallTitle: "bannerSmallTitle.mermaidFishing",
        flag: 0,
        right: true
      }, {
        picUrl: __webpack_require__("d1S8"),
        title: "banner.dezhou_qz",
        smallTitle: "bannerSmallTitle.dezhou_qz",
        flag: 0
      }, {
        picUrl: __webpack_require__("EyRZ"),
        title: "banner.errenmj",
        smallTitle: "bannerSmallTitle.errenmj",
        flag: 0,
        right: true
      }, {
        picUrl: __webpack_require__("BeLy"),
        title: "banner.ksznn_3d",
        smallTitle: "bannerSmallTitle.ksznn_3d",
        flag: 0
      }, {
        picUrl: __webpack_require__("Abqo"),
        title: "banner.qznn_3d",
        smallTitle: "bannerSmallTitle.qznn_3d",
        flag: 0
      }, {
        picUrl: __webpack_require__("YIAk"),
        title: "banner.ddzjs",
        smallTitle: "bannerSmallTitle.ddzjs",
        flag: 0
      }, {
        picUrl: __webpack_require__("vDf8"),
        title: "banner.jokerNiuniu",
        smallTitle: "bannerSmallTitle.jokerNiuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("SFn8"),
        title: "banner.lkpy",
        smallTitle: "bannerSmallTitle.lkpy",
        flag: 0
      }, {
        picUrl: __webpack_require__("Sj6I"),
        title: "banner.dntg",
        smallTitle: "bannerSmallTitle.dntg",
        flag: 0
      }, {
        picUrl: __webpack_require__("5evJ"),
        title: "banner.goldenCountry",
        smallTitle: "bannerSmallTitle.goldenCountry",
        flag: 0
      }, {
        picUrl: __webpack_require__("I+wM"),
        title: "banner.birdingJoy",
        smallTitle: "bannerSmallTitle.birdingJoy",
        flag: 0
      }, {
        picUrl: __webpack_require__("sKtX"),
        title: "banner.forestParty",
        smallTitle: "bannerSmallTitle.forestParty",
        flag: 13
      }, {
        picUrl: __webpack_require__("GZ8D"),
        title: "banner.majiangxuezhan",
        smallTitle: "bannerSmallTitle.majiangxuezhan",
        flag: 13
      }, {
        picUrl: __webpack_require__("Zzmh"),
        title: "banner.landlord",
        smallTitle: "bannerSmallTitle.landlord",
        flag: 13
      }, {
        picUrl: __webpack_require__("Egis"),
        title: "banner.jinsaPoker",
        smallTitle: "bannerSmallTitle.jinsaPoker",
        flag: 13
      }],
      swiperOptionTop: {
        // spaceBetween: 8,
        // spaceBetween: 30,
        observer: true,
        observeParents: true,
        loop: true,
        //loopAdditionalSlides: 3,
        // swiperSlides: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        // loopFillGroupWithBlank: true,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next-self",
          prevEl: ".swiper-button-prev-self"
        },
        //paginationClickable: true,
        autoplayDisableOnInteraction: false,
        // pagination: {
        //     //   el: ".swiper-pagination",
        //     el: ".pic-btn",
        //     //   type: "custom",
        //     clickable: true,
        //     paginationType: "custom"
        // },
        on: {
          slideChange: function () {
            this.aIndex = this.$refs.swiperTop.swiper ? this.$refs.swiperTop.swiper.activeIndex : 1;
            // console.log(this.$refs.swiperTop.swiper, 741, this.aIndex);
          }.bind(this)
        }
        // debugger: true
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Thumbnail/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_Thumbnail = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  methods: {
    handleVideo: function handleVideo(index) {
      this.$emit("modalClick", true, index);
    },
    bannerChange: function bannerChange() {
      var _this = this;

      var index = this.aIndex;
      this.bannerImgList = [];
      this.$nextTick(function () {
        _this.bannerImgList = _this.bannerList;
        _this.$nextTick(function () {
          _this.$refs.swiperTop.swiper.slideTo(index, 100);
          _this.$refs.swiperTop.swiper.update(true);
        });
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  watch: {
    // isMobile(v) {
    //   this.bannerChange();
    // },
    lang: function lang(v) {
      this.bannerChange();
    }
  },
  mounted: function mounted() {
    this.bannerChange();
  },
  updated: function updated() {
    // this.bannerChange();
  },
  data: function data() {
    return {
      aIndex: 1,
      changeDir: "image",
      bannerImgList: [],
      bannerList: [{
        picUrl: __webpack_require__("yF/s"),
        title: "banner.baijiale",
        smallTitle: "bannerSmallTitle.baijiale",
        flag: 0
      }, {
        picUrl: __webpack_require__("Z1XC"),
        title: "banner.lunpan",
        smallTitle: "bannerSmallTitle.lunpan",
        flag: 0
      }, {
        picUrl: __webpack_require__("+oo4"),
        title: "banner.buyu",
        smallTitle: "bannerSmallTitle.buyu",
        flag: 0
      }, {
        picUrl: __webpack_require__("2Jms"),
        title: "banner.zhanjinhua",
        smallTitle: "bannerSmallTitle.zhanjinhua",
        flag: 0
      }, {
        picUrl: __webpack_require__("dVNw"),
        title: "banner.niuniu",
        smallTitle: "bannerSmallTitle.niuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("KcI4"),
        title: "banner.tuiTongzi",
        smallTitle: "bannerSmallTitle.tuiTongzi",
        flag: 0
      }, {
        picUrl: __webpack_require__("zYMp"),
        title: "banner.longhu",
        smallTitle: "bannerSmallTitle.longhu",
        flag: 0
      }, {
        picUrl: __webpack_require__("XLW9"),
        title: "banner.dezhou",
        smallTitle: "bannerSmallTitle.dezhou",
        flag: 0
      }, {
        picUrl: __webpack_require__("/NOx"),
        title: "banner.jisuhua",
        smallTitle: "bannerSmallTitle.jisuhua",
        flag: 0
      }, {
        picUrl: __webpack_require__("+b8s"),
        title: "banner.shisanshui",
        smallTitle: "bannerSmallTitle.shisanshui",
        flag: 0
      }, {
        picUrl: __webpack_require__("BfMz"),
        title: "banner.paijiu",
        smallTitle: "bannerSmallTitle.paijiu",
        flag: 0
      }, {
        picUrl: __webpack_require__("jylW"),
        title: "banner.kingOfFishing3D",
        smallTitle: "bannerSmallTitle.kingOfFishing3D",
        flag: 0
      }, {
        picUrl: __webpack_require__("evfb"),
        title: "banner.ershiyidian",
        smallTitle: "bannerSmallTitle.ershiyidian",
        flag: 0
      }, {
        picUrl: __webpack_require__("9zhb"),
        title: "banner.bairenbaijiale",
        smallTitle: "bannerSmallTitle.bairenbaijiale",
        flag: 0
      }, {
        picUrl: __webpack_require__("upOt"),
        title: "banner.honghei",
        smallTitle: "bannerSmallTitle.honghei",
        flag: 0
      }, {
        picUrl: __webpack_require__("Z8hn"),
        title: "banner.shidianban",
        smallTitle: "bannerSmallTitle.shidianban",
        flag: 0
      }, {
        picUrl: __webpack_require__("91nV"),
        title: "banner.niuniu4",
        smallTitle: "bannerSmallTitle.niuniu4",
        flag: 0
      }, {
        picUrl: __webpack_require__("YYzr"),
        title: "banner.bairenniuniu",
        smallTitle: "bannerSmallTitle.bairenniuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("oMHB"),
        title: "banner.majiangxueliu",
        smallTitle: "bannerSmallTitle.majiangxueliu",
        flag: 0
      }, {
        picUrl: __webpack_require__("MfcT"),
        title: "banner.benzAndBMW",
        smallTitle: "bannerSmallTitle.benzAndBMW",
        flag: 0
      }, {
        picUrl: __webpack_require__("Id51"),
        title: "banner.fanbeimajiang",
        smallTitle: "bannerSmallTitle.fanbeimajiang",
        flag: 0
      }, {
        picUrl: __webpack_require__("1F9U"),
        title: "banner.pirateFishing",
        smallTitle: "bannerSmallTitle.pirateFishing",
        flag: 0
      }, {
        picUrl: __webpack_require__("whnJ"),
        title: "banner.mermaidFishing",
        smallTitle: "bannerSmallTitle.mermaidFishing",
        flag: 0,
        right: true
      }, {
        picUrl: __webpack_require__("d1S8"),
        title: "banner.dezhou_qz",
        smallTitle: "bannerSmallTitle.dezhou_qz",
        flag: 0
      }, {
        picUrl: __webpack_require__("EyRZ"),
        title: "banner.errenmj",
        smallTitle: "bannerSmallTitle.errenmj",
        flag: 0,
        right: true
      }, {
        picUrl: __webpack_require__("BeLy"),
        title: "banner.ksznn_3d",
        smallTitle: "bannerSmallTitle.ksznn_3d",
        flag: 0
      }, {
        picUrl: __webpack_require__("Abqo"),
        title: "banner.qznn_3d",
        smallTitle: "bannerSmallTitle.qznn_3d",
        flag: 0
      }, {
        picUrl: __webpack_require__("YIAk"),
        title: "banner.ddzjs",
        smallTitle: "bannerSmallTitle.ddzjs",
        flag: 0
      }, {
        picUrl: __webpack_require__("vDf8"),
        title: "banner.jokerNiuniu",
        smallTitle: "bannerSmallTitle.jokerNiuniu",
        flag: 0
      }, {
        picUrl: __webpack_require__("SFn8"),
        title: "banner.lkpy",
        smallTitle: "bannerSmallTitle.lkpy",
        flag: 0
      }, {
        picUrl: __webpack_require__("Sj6I"),
        title: "banner.dntg",
        smallTitle: "bannerSmallTitle.dntg",
        flag: 0
      }, {
        picUrl: __webpack_require__("5evJ"),
        title: "banner.goldenCountry",
        smallTitle: "bannerSmallTitle.goldenCountry",
        flag: 0
      }, {
        picUrl: __webpack_require__("I+wM"),
        title: "banner.birdingJoy",
        smallTitle: "bannerSmallTitle.birdingJoy",
        flag: 0
      }, {
        picUrl: __webpack_require__("sKtX"),
        title: "banner.forestParty",
        smallTitle: "bannerSmallTitle.forestParty",
        flag: 13
      }, {
        picUrl: __webpack_require__("GZ8D"),
        title: "banner.majiangxuezhan",
        smallTitle: "bannerSmallTitle.majiangxuezhan",
        flag: 13
      }, {
        picUrl: __webpack_require__("Zzmh"),
        title: "banner.landlord",
        smallTitle: "bannerSmallTitle.landlord",
        flag: 13
      }, {
        picUrl: __webpack_require__("Egis"),
        title: "banner.jinsaPoker",
        smallTitle: "bannerSmallTitle.jinsaPoker",
        flag: 13
      }],
      swiperOptionTop: {
        // spaceBetween: 8,
        // spaceBetween: 30,
        observer: true,
        observeParents: true,
        loop: true,
        //loopAdditionalSlides: 3,
        // swiperSlides: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
        // loopFillGroupWithBlank: true,
        centeredSlides: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next-self",
          prevEl: ".swiper-button-prev-self"
        },
        //paginationClickable: true,
        autoplayDisableOnInteraction: false,
        // pagination: {
        //     //   el: ".swiper-pagination",
        //     el: ".pic-btn",
        //     //   type: "custom",
        //     clickable: true,
        //     paginationType: "custom"
        // },
        on: {
          slideChange: function () {
            this.aIndex = this.$refs.swiperTop.swiper ? this.$refs.swiperTop.swiper.activeIndex : 1;
            // console.log(this.$refs.swiperTop.swiper, 741, this.aIndex);
          }.bind(this)
        }
        // debugger: true
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2820f560","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thumbnail/index.vue
var Thumbnail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Thumbnail-wrap"},[(_vm.bannerImgList.length > 1)?_c('swiper',{ref:"swiperTop",staticClass:"gallery-top",attrs:{"options":_vm.swiperOptionTop}},[_vm._l((_vm.bannerImgList),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{attrs:{"src":item.picUrl,"alt":""}}),_vm._v(" "),_c('div',{class:{ 'banner-words': true, right: item.right }},[_c('p',{staticClass:"font-gradation banner-font"},[_vm._v(_vm._s(_vm.$t(item.title)))]),_vm._v(" "),(_vm.lang != 'en')?_c('p',{staticClass:"font-gradation banner-font-24"},[_vm._v("\n            "+_vm._s(_vm.$t(item.smallTitle))+"\n          ")]):_vm._e()]),_vm._v(" "),(index < 5)?_c('div',{staticClass:"testDiv",on:{"click":function($event){return _vm.handleVideo(index)}}}):_vm._e(),_vm._v(" "),(item.flag != 0)?_c('div',{staticClass:"bannerMask"},[_c('div',{staticClass:"p-box"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.$t("LaunchedMonth." + item.flag)))]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v(_vm._s(_vm.$t("banner.coming")))])])]):_vm._e()])}),_vm._v(" "),_c('span',{staticClass:"pic-btn",attrs:{"slot":"pagination"},slot:"pagination"})],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"btn-video"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next-self",attrs:{"slot":"button-next"},slot:"button-next"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev-self",attrs:{"slot":"button-prev"},slot:"button-prev"})],1)}
var staticRenderFns = []
var esExports = { render: Thumbnail_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Thumbnail = (esExports);
// CONCATENATED MODULE: ./src/components/Thumbnail/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("yBDv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_Thumbnail,
  selectortype_template_index_0_src_components_Thumbnail,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Thumbnail = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/toggleGame/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toggleGame = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    mdButton: vue_awesome_swiper["mdButton"],
    mdCard: vue_awesome_swiper["mdCard"],
    mdCardActions: vue_awesome_swiper["mdCardActions"],
    mdCardMedia: vue_awesome_swiper["mdCardMedia"]
  },
  methods: {
    handleOpenGame: function handleOpenGame(item) {
      // var l = String(window.location.hostname).match(
      //   "(\\w*\\.?){2}\\.(com.cn|net.cn|gov.cn|org\\.nz|org.cn|com|net|org|gov|cc|biz|info|cn|co)$"
      // );
      // if (l && l.length == 3) {
      //   var u = "//api." + l[1] + "." + l[2] + "/Api/trial";
      //   window.open(u);
      // }
      if (item && item.url.trim() != "" && item.url != "#") {
        window.open(item.url);
      } else {
        alert(this.$t("indexPagePlay.development"));
      }
      return false;
    },
    toggleToSlide: function toggleToSlide(index) {
      // console.log(this.$refs.toggleGameSwiper, 568);
      this.activeIndex = index;
      this.$refs.toggleGameSwiper.swiper.slideTo(index, 200);
    },
    toggleHeight: function toggleHeight() {
      if (window.innerWidth > 700) {
        // this.$store.dispatch("setAutoHeight", false);
        // this.swiperOption.autoHeight = false;
        this.$refs.toggleGameSwiper.options.autoHeight = false;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.swiperOption, 564);
        // alert(1);
      } else {
        // this.$store.dispatch("setAutoHeight", true);
        // this.swiperOption.autoHeight = true;
        this.$refs.toggleGameSwiper.options.autoHeight = true;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.$refs.toggleGameSwiper, 123);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    autoHeight: function autoHeight(state) {
      return state.app.autoHeight;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    this.toggleHeight();
    window.onresize = function () {
      _this.toggleHeight();
    };
  },

  watch: {
    // $t(newVal, oldVal) {
    //   // console.log(newVal, oldVal);
    //   return (oldVal = newVal);
    // }
  },
  data: function data() {
    return {
      activeIndex: 0,
      onLineBanner: [{
        picUrl: __webpack_require__("4pSx"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.a"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("Al4e"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.b"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("5Ogl"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.c"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("D13e"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.d"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("TlwD"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.e"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("4m/A"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.f"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("BUTA"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.g"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("ZxhC"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.h"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("MLVY"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.i"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("obpj"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.j"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("BU3T"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.k"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("8MA0"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.l"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("3uMc"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.n"
      }, {
        picUrl: __webpack_require__("SUAD"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.sangong"
        // title: "三公"
      }, {
        picUrl: __webpack_require__("lleX"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.shidianban"
      }, {
        picUrl: __webpack_require__("yyZe"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.ershiyidian"
        // title: "二十一点"
      }, {
        picUrl: __webpack_require__("RZzK"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.bairenbaijiale"
        // title: "二十一点"
      }, {
        picUrl: __webpack_require__("zmfZ"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.honghei"
      }, {
        picUrl: __webpack_require__("nFl9"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.online.m"
      }, {
        picUrl: __webpack_require__("BWXV"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.bairenniuniu"
      }, {
        picUrl: __webpack_require__("Xe6N"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.niuniu4"
      }, {
        picUrl: __webpack_require__("C//j"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.MahjongKing.xueliumajiang"
        // title: "血流麻将"
      }, {
        picUrl: __webpack_require__("Gej+"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.MahjongKing.fanbeimajiang"
        // title: "翻倍血流"
      }, {
        picUrl: __webpack_require__("4Fbv"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.electronGame.benchibaoma"
        // title: "奔驰宝马"
      }, {
        picUrl: __webpack_require__("iBgm"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.pirateFishing"
        // title: "3D海盗捕鱼王"
      }, {
        picUrl: __webpack_require__("ZFFU"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.mermaidFishing"
        // title: "3D美人鱼捕鱼"
      }, {
        picUrl: __webpack_require__("aLG7"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.dezhou_qz"
        // title: "德州扑克（前注场）"
      }, {
        picUrl: __webpack_require__("P41L"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.errenmj"
        // title: "二人麻将"
      }, {
        picUrl: __webpack_require__("ps3f"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.ksznn_3d"
        // title: "3D看四张牛牛"
      }, {
        picUrl: __webpack_require__("pPjQ"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.qznn_3d"
        // title: "3D抢庄牛牛"
      }, {
        picUrl: __webpack_require__("X1gC"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.doudizhu1"
        // title: "斗地主（极速）"
      }, {
        picUrl: __webpack_require__("cSTo"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.zhajinhua3d"
        // title: "3d炸金花"
      }, {
        picUrl: __webpack_require__("0Dms"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.jokerNiuniu"
        // title: "癞子牛牛"
      }, {
        picUrl: __webpack_require__("hH10"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.kszqznn"
        // title: "看三张抢庄牛牛"
      }, {
        picUrl: __webpack_require__("XpBD"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.dntg"
        // title: "大闹天宫"
      }, {
        picUrl: __webpack_require__("hxFk"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.lkpy"
        // title: "李逵劈鱼"
      }, {
        picUrl: __webpack_require__("6bm5"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.goldenCountry"
        // title: "黄金国度"
      }, {
        picUrl: __webpack_require__("5/6a"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.birdingJoy"
        // title: "捕鸟达人"
      }],
      qipaiBanner: [{
        picUrl: __webpack_require__("jAZE"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.tongbi"
        // title: "通比推筒子"
      }, {
        picUrl: __webpack_require__("GGvJ"),
        className: "list4",
        url: "#",
        title: "gameName.qipaiKind.paijiu"
        // title: "抢庄牌九"
      }, {
        picUrl: __webpack_require__("zLiC"),
        className: "list1",
        url: "#",
        title: "gameName.qipaiKind.guandao"
        // title: "掼蛋"
      }, {
        picUrl: __webpack_require__("tbN9"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.jialebipuke"
        // title: "加勒比扑克"
      }, {
        picUrl: __webpack_require__("t1li"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.paohuzi"
        // title: "跑胡子"
      }, {
        picUrl: __webpack_require__("3SGe"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.shaibao"
        // title: "骰宝"
      },
      // {
      //   picUrl: require("@/assets/static/gameImg/bairenniuniu.jpg"),
      //   className: "list3",
      //   url: "#",
      //   title: "gameName.qipaiKind.bairenniuniu"
      // },
      {
        picUrl: __webpack_require__("nB2o"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.sanzhangpuke"
        // title: "三张扑克"
      }, {
        picUrl: __webpack_require__("MIBB"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.doudizhu2"
        // title: "斗地主（不洗牌）"
      },
      //
      {
        picUrl: __webpack_require__("6OjC"),
        className: "list4",
        url: "#",
        title: "gameName.qipaiKind.qiangzhuangtuitongzi"
        // title: "抢庄推筒子"
      }, {
        picUrl: __webpack_require__("4bXQ"),
        className: "list4",
        url: "#",
        title: "banner.jinsaPoker"
      }, {
        picUrl: __webpack_require__("LDsI"),
        // game-develop
        className: "",
        url: "#",
        title: "gameName.qipaiKind.developGame"
        // title: "更多游戏"
      }],
      dianziBanner: [{
        picUrl: __webpack_require__("VSyL"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.laohuji"
        // title: "老虎机"
      }, {
        picUrl: __webpack_require__("8kkO"),
        className: "list4",
        url: "#",
        title: "gameName.electronGame.senlinwuhui"
        // title: "森林舞会"
      }, {
        picUrl: __webpack_require__("YXis"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.taiqiudashi"
        // title: "台球大师"
      }, {
        picUrl: __webpack_require__("UHeo"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.shuiguopaidui"
        // title: "水果派对"
      }, {
        picUrl: __webpack_require__("aekv"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.feiqinzoushou"
        // title: "飞禽走兽"
      }, {
        picUrl: __webpack_require__("9sIl"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.wangzhezuqiu"
        // title: "王者足球"
      }, {
        picUrl: __webpack_require__("ywh3"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.xingyunwu"
        // title: "幸运五"
      }, {
        picUrl: __webpack_require__("LDsI"),
        // game-develop
        className: "list4",
        url: "#",
        title: "gameName.electronGame.developGame"
        // title: "更多游戏"
      }],
      majiangBanner: [{
        picUrl: __webpack_require__("YP1G"),
        className: "list2",
        url: "#",
        title: "gameName.MahjongKing.guangdongmajiang"
        // title: "广东麻将"
      }, {
        picUrl: __webpack_require__("+k7N"),
        className: "list3",
        url: "#",
        title: "gameName.MahjongKing.zhuajimajiang"
        // title: "抓鸡麻将"
      }, {
        picUrl: __webpack_require__("9dt9"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.dongbeimajiang"
        // title: "东北麻将"
      }, {
        picUrl: __webpack_require__("Wjjm"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.taimajiang"
        // title: "台湾麻将"
      }, {
        picUrl: __webpack_require__("h+oE"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.guojimajiang"
        // title: "国际麻将"
      }, {
        picUrl: __webpack_require__("1vqm"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.hangzhoumajiang"
        // title: "杭州麻将"
      }, {
        picUrl: __webpack_require__("1uPM"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.kawufumajiang"
        // title: "卡五福麻将"
      }, {
        picUrl: __webpack_require__("iyji"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.xuezhanmajiang"
        // title: "血战麻将"
      }, {
        picUrl: __webpack_require__("474U"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.fuzhoumajiang"
        // title: "福州麻将"
      }, {
        picUrl: __webpack_require__("8R+o"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.zhongyongmajiang"
        // title: "中庸麻将"
      }],
      // bunieBanner: [
      //   {
      //     picUrl: require("@/assets/static/gameImg/buniaolueshou.jpg"),
      //     className: "buniaolueshou",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.buniaolueshou"
      //     // title: "捕鸟猎手"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingjidazhan.jpg"),
      //     className: "xingjidazhan",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingjidazhan"
      //     // title: "星际大战"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingyunbuyu.jpg"),
      //     className: "xingyunbuyu",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingyunbuyu"
      //     // title: "幸运捕鱼"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/developGame.jpg"),
      //     // className: "developGame", game-develop
      //     className: "list4",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.developGame"
      //     // title: "更多游戏"
      //   }
      // ],
      gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
      swiperOption: {
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function () {
            this.activeIndex = this.$refs.toggleGameSwiper.swiper.activeIndex;
          }.bind(this)
        }
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/toggleGame/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toggleGame = ({
  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"],
    mdButton: vue_awesome_swiper["mdButton"],
    mdCard: vue_awesome_swiper["mdCard"],
    mdCardActions: vue_awesome_swiper["mdCardActions"],
    mdCardMedia: vue_awesome_swiper["mdCardMedia"]
  },
  methods: {
    handleOpenGame: function handleOpenGame(item) {
      // var l = String(window.location.hostname).match(
      //   "(\\w*\\.?){2}\\.(com.cn|net.cn|gov.cn|org\\.nz|org.cn|com|net|org|gov|cc|biz|info|cn|co)$"
      // );
      // if (l && l.length == 3) {
      //   var u = "//api." + l[1] + "." + l[2] + "/Api/trial";
      //   window.open(u);
      // }
      if (item && item.url.trim() != "" && item.url != "#") {
        window.open(item.url);
      } else {
        alert(this.$t("indexPagePlay.development"));
      }
      return false;
    },
    toggleToSlide: function toggleToSlide(index) {
      // console.log(this.$refs.toggleGameSwiper, 568);
      this.activeIndex = index;
      this.$refs.toggleGameSwiper.swiper.slideTo(index, 200);
    },
    toggleHeight: function toggleHeight() {
      if (window.innerWidth > 700) {
        // this.$store.dispatch("setAutoHeight", false);
        // this.swiperOption.autoHeight = false;
        this.$refs.toggleGameSwiper.options.autoHeight = false;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.swiperOption, 564);
        // alert(1);
      } else {
        // this.$store.dispatch("setAutoHeight", true);
        // this.swiperOption.autoHeight = true;
        this.$refs.toggleGameSwiper.options.autoHeight = true;
        // this.$refs.toggleGameSwiper.init();
        // console.log(this.$refs.toggleGameSwiper, 123);
      }
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    autoHeight: function autoHeight(state) {
      return state.app.autoHeight;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  mounted: function mounted() {
    var _this = this;

    this.toggleHeight();
    window.onresize = function () {
      _this.toggleHeight();
    };
  },

  watch: {
    // $t(newVal, oldVal) {
    //   // console.log(newVal, oldVal);
    //   return (oldVal = newVal);
    // }
  },
  data: function data() {
    return {
      activeIndex: 0,
      onLineBanner: [{
        picUrl: __webpack_require__("4pSx"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.a"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("Al4e"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.b"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("5Ogl"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.c"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("D13e"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.d"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("TlwD"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.e"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("4m/A"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.f"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("BUTA"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.g"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("ZxhC"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.h"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("MLVY"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.i"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("obpj"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.j"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("BU3T"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.k"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("8MA0"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.l"
        // title: "百家乐"
      }, {
        picUrl: __webpack_require__("3uMc"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.online.n"
      }, {
        picUrl: __webpack_require__("SUAD"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.sangong"
        // title: "三公"
      }, {
        picUrl: __webpack_require__("lleX"),
        className: "list1",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.shidianban"
      }, {
        picUrl: __webpack_require__("yyZe"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.ershiyidian"
        // title: "二十一点"
      }, {
        picUrl: __webpack_require__("RZzK"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.bairenbaijiale"
        // title: "二十一点"
      }, {
        picUrl: __webpack_require__("zmfZ"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.honghei"
      }, {
        picUrl: __webpack_require__("nFl9"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.online.m"
      }, {
        picUrl: __webpack_require__("BWXV"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.bairenniuniu"
      }, {
        picUrl: __webpack_require__("Xe6N"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "banner.niuniu4"
      }, {
        picUrl: __webpack_require__("C//j"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.MahjongKing.xueliumajiang"
        // title: "血流麻将"
      }, {
        picUrl: __webpack_require__("Gej+"),
        className: "list4",
        url: this.$url + "/api/trial",
        title: "gameName.MahjongKing.fanbeimajiang"
        // title: "翻倍血流"
      }, {
        picUrl: __webpack_require__("4Fbv"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.electronGame.benchibaoma"
        // title: "奔驰宝马"
      }, {
        picUrl: __webpack_require__("iBgm"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.pirateFishing"
        // title: "3D海盗捕鱼王"
      }, {
        picUrl: __webpack_require__("ZFFU"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.mermaidFishing"
        // title: "3D美人鱼捕鱼"
      }, {
        picUrl: __webpack_require__("aLG7"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.dezhou_qz"
        // title: "德州扑克（前注场）"
      }, {
        picUrl: __webpack_require__("P41L"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.errenmj"
        // title: "二人麻将"
      }, {
        picUrl: __webpack_require__("ps3f"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.ksznn_3d"
        // title: "3D看四张牛牛"
      }, {
        picUrl: __webpack_require__("pPjQ"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "banner.qznn_3d"
        // title: "3D抢庄牛牛"
      }, {
        picUrl: __webpack_require__("X1gC"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.doudizhu1"
        // title: "斗地主（极速）"
      }, {
        picUrl: __webpack_require__("cSTo"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.zhajinhua3d"
        // title: "3d炸金花"
      }, {
        picUrl: __webpack_require__("0Dms"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.jokerNiuniu"
        // title: "癞子牛牛"
      }, {
        picUrl: __webpack_require__("hH10"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.qipaiKind.kszqznn"
        // title: "看三张抢庄牛牛"
      }, {
        picUrl: __webpack_require__("XpBD"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.dntg"
        // title: "大闹天宫"
      }, {
        picUrl: __webpack_require__("hxFk"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.lkpy"
        // title: "李逵劈鱼"
      }, {
        picUrl: __webpack_require__("6bm5"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.goldenCountry"
        // title: "黄金国度"
      }, {
        picUrl: __webpack_require__("5/6a"),
        className: "list3",
        url: this.$url + "/api/trial",
        title: "gameName.online.birdingJoy"
        // title: "捕鸟达人"
      }],
      qipaiBanner: [{
        picUrl: __webpack_require__("jAZE"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.tongbi"
        // title: "通比推筒子"
      }, {
        picUrl: __webpack_require__("GGvJ"),
        className: "list4",
        url: "#",
        title: "gameName.qipaiKind.paijiu"
        // title: "抢庄牌九"
      }, {
        picUrl: __webpack_require__("zLiC"),
        className: "list1",
        url: "#",
        title: "gameName.qipaiKind.guandao"
        // title: "掼蛋"
      }, {
        picUrl: __webpack_require__("tbN9"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.jialebipuke"
        // title: "加勒比扑克"
      }, {
        picUrl: __webpack_require__("t1li"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.paohuzi"
        // title: "跑胡子"
      }, {
        picUrl: __webpack_require__("3SGe"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.shaibao"
        // title: "骰宝"
      },
      // {
      //   picUrl: require("@/assets/static/gameImg/bairenniuniu.jpg"),
      //   className: "list3",
      //   url: "#",
      //   title: "gameName.qipaiKind.bairenniuniu"
      // },
      {
        picUrl: __webpack_require__("nB2o"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.sanzhangpuke"
        // title: "三张扑克"
      }, {
        picUrl: __webpack_require__("MIBB"),
        className: "list3",
        url: "#",
        title: "gameName.qipaiKind.doudizhu2"
        // title: "斗地主（不洗牌）"
      },
      //
      {
        picUrl: __webpack_require__("6OjC"),
        className: "list4",
        url: "#",
        title: "gameName.qipaiKind.qiangzhuangtuitongzi"
        // title: "抢庄推筒子"
      }, {
        picUrl: __webpack_require__("4bXQ"),
        className: "list4",
        url: "#",
        title: "banner.jinsaPoker"
      }, {
        picUrl: __webpack_require__("LDsI"),
        // game-develop
        className: "",
        url: "#",
        title: "gameName.qipaiKind.developGame"
        // title: "更多游戏"
      }],
      dianziBanner: [{
        picUrl: __webpack_require__("VSyL"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.laohuji"
        // title: "老虎机"
      }, {
        picUrl: __webpack_require__("8kkO"),
        className: "list4",
        url: "#",
        title: "gameName.electronGame.senlinwuhui"
        // title: "森林舞会"
      }, {
        picUrl: __webpack_require__("YXis"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.taiqiudashi"
        // title: "台球大师"
      }, {
        picUrl: __webpack_require__("UHeo"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.shuiguopaidui"
        // title: "水果派对"
      }, {
        picUrl: __webpack_require__("aekv"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.feiqinzoushou"
        // title: "飞禽走兽"
      }, {
        picUrl: __webpack_require__("9sIl"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.wangzhezuqiu"
        // title: "王者足球"
      }, {
        picUrl: __webpack_require__("ywh3"),
        className: "list3",
        url: "#",
        title: "gameName.electronGame.xingyunwu"
        // title: "幸运五"
      }, {
        picUrl: __webpack_require__("LDsI"),
        // game-develop
        className: "list4",
        url: "#",
        title: "gameName.electronGame.developGame"
        // title: "更多游戏"
      }],
      majiangBanner: [{
        picUrl: __webpack_require__("YP1G"),
        className: "list2",
        url: "#",
        title: "gameName.MahjongKing.guangdongmajiang"
        // title: "广东麻将"
      }, {
        picUrl: __webpack_require__("+k7N"),
        className: "list3",
        url: "#",
        title: "gameName.MahjongKing.zhuajimajiang"
        // title: "抓鸡麻将"
      }, {
        picUrl: __webpack_require__("9dt9"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.dongbeimajiang"
        // title: "东北麻将"
      }, {
        picUrl: __webpack_require__("Wjjm"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.taimajiang"
        // title: "台湾麻将"
      }, {
        picUrl: __webpack_require__("h+oE"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.guojimajiang"
        // title: "国际麻将"
      }, {
        picUrl: __webpack_require__("1vqm"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.hangzhoumajiang"
        // title: "杭州麻将"
      }, {
        picUrl: __webpack_require__("1uPM"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.kawufumajiang"
        // title: "卡五福麻将"
      }, {
        picUrl: __webpack_require__("iyji"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.xuezhanmajiang"
        // title: "血战麻将"
      }, {
        picUrl: __webpack_require__("474U"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.fuzhoumajiang"
        // title: "福州麻将"
      }, {
        picUrl: __webpack_require__("8R+o"),
        className: "list4",
        url: "#",
        title: "gameName.MahjongKing.zhongyongmajiang"
        // title: "中庸麻将"
      }],
      // bunieBanner: [
      //   {
      //     picUrl: require("@/assets/static/gameImg/buniaolueshou.jpg"),
      //     className: "buniaolueshou",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.buniaolueshou"
      //     // title: "捕鸟猎手"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingjidazhan.jpg"),
      //     className: "xingjidazhan",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingjidazhan"
      //     // title: "星际大战"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/xingyunbuyu.jpg"),
      //     className: "xingyunbuyu",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.xingyunbuyu"
      //     // title: "幸运捕鱼"
      //   },
      //   {
      //     picUrl: require("@/assets/static/gameImg/developGame.jpg"),
      //     // className: "developGame", game-develop
      //     className: "list4",
      //     url: " https://api.gcpadi.com/api/trial",
      //     title: "gameName.hunterKing.developGame"
      //     // title: "更多游戏"
      //   }
      // ],
      gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
      swiperOption: {
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function () {
            this.activeIndex = this.$refs.toggleGameSwiper.swiper.activeIndex;
          }.bind(this)
        }
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-514c5fd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toggleGame/index.vue
var toggleGame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-toggle-wrapper"},[_c('div',{staticClass:"nav-wrap"},[_c('ul',{staticClass:"clearfix"},[_c('li',{class:{ activeClass: _vm.activeIndex == 0 },on:{"click":function($event){return _vm.toggleToSlide(0)}}},[_c('span',{class:{ 'font-gradation': 0 == 0 }},[_vm._v("\n          "+_vm._s(_vm.$t("NavTitle.online"))+"\n        ")])]),_vm._v(" "),_c('li',{class:{ activeClass: _vm.activeIndex == 1 },on:{"click":function($event){return _vm.toggleToSlide(1)}}},[_c('span',{class:{ 'font-gradation': 1 == 1 }},[_vm._v("\n          "+_vm._s(_vm.$t("NavTitle.qipaiKind"))+"\n        ")])]),_vm._v(" "),_c('li',{class:{ activeClass: _vm.activeIndex == 2 },on:{"click":function($event){return _vm.toggleToSlide(2)}}},[_c('span',{class:{ 'font-gradation': 2 == 2 }},[_vm._v("\n          "+_vm._s(_vm.$t("NavTitle.electronGame"))+"\n        ")])]),_vm._v(" "),_c('li',{class:{ activeClass: _vm.activeIndex == 3 },on:{"click":function($event){return _vm.toggleToSlide(3)}}},[_c('span',{class:{ 'font-gradation': 3 == 3 }},[_vm._v("\n          "+_vm._s(_vm.$t("NavTitle.MahjongKing"))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"game-toggle-box"},[_c('div',{staticClass:"swiper-game-wrap"},[_c('swiper',{ref:"toggleGameSwiper",staticClass:"game-option",attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',{ref:"imglistUlSmall5"},[_c('ul',{staticClass:"clearfix manyGame-ul bunie-ul"},[_vm._l((_vm.onLineBanner),function(item,i){return [_c('li',{key:i,staticClass:"online-li",on:{"click":function($event){return _vm.handleOpenGame(item)}}},[(String(item.title).indexOf('developGame') > -1)?[(_vm.lang == 'en')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("DHzu")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'zh-CN')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("LDsI")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'taiwan')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("mH5o")}}):_vm._e()]:_c('img',{class:item.className,attrs:{"src":item.picUrl}}),_vm._v(" "),_c('div',{staticClass:"mask2"}),_vm._v(" "),_c('div',{staticClass:"content2"},[_c('a',{staticClass:"info"},[_vm._v("\n                    "+_vm._s(_vm.$t("indexPagePlay.inGame"))+"\n                  ")])]),_vm._v(" "),_c('p',[_c('span',{staticClass:"font-gradation",staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$t(item.title)))])])],2)]})],2)]),_vm._v(" "),_c('swiper-slide',[_c('ul',{ref:"imglistUlSmall1",staticClass:"clearfix manyGame-ul"},[_vm._l((_vm.qipaiBanner),function(item,i){return [_c('li',{key:i,on:{"click":function($event){return _vm.handleOpenGame(item)}}},[(String(item.title).indexOf('developGame') > -1)?[(_vm.lang == 'en')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("DHzu")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'zh-CN')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("LDsI")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'taiwan')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("mH5o")}}):_vm._e()]:_c('img',{class:item.className,attrs:{"src":item.picUrl}}),_vm._v(" "),_c('div',{staticClass:"mask"}),_vm._v(" "),_c('a',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.development")))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"font-gradation",staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$t(item.title)))])])],2)]})],2)]),_vm._v(" "),_c('swiper-slide',[_c('ul',{ref:"imglistUlSmall2",staticClass:"clearfix manyGame-ul"},[_vm._l((_vm.dianziBanner),function(item,i){return [_c('li',{key:i,on:{"click":function($event){return _vm.handleOpenGame(item)}}},[(String(item.title).indexOf('developGame') > -1)?[(_vm.lang == 'en')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("DHzu")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'zh-CN')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("LDsI")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'taiwan')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("mH5o")}}):_vm._e()]:_c('img',{class:item.className,attrs:{"src":item.picUrl}}),_vm._v(" "),_c('div',{staticClass:"mask"}),_vm._v(" "),_c('a',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.development")))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"font-gradation",staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$t(item.title)))])])],2)]})],2)]),_vm._v(" "),_c('swiper-slide',[_c('ul',{ref:"imglistUlSmall3",staticClass:"clearfix manyGame-ul"},[_vm._l((_vm.majiangBanner),function(item,i){return [_c('li',{key:i,on:{"click":function($event){return _vm.handleOpenGame(item)}}},[(String(item.title).indexOf('developGame') > -1)?[(_vm.lang == 'en')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("DHzu")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'zh-CN')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("LDsI")}}):_vm._e(),_vm._v(" "),(_vm.lang == 'taiwan')?_c('img',{class:item.className,attrs:{"src":__webpack_require__("mH5o")}}):_vm._e()]:_c('img',{class:item.className,attrs:{"src":item.picUrl}}),_vm._v(" "),_c('div',{staticClass:"mask"}),_vm._v(" "),_c('a',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.development")))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"font-gradation",staticStyle:{"text-transform":"uppercase"}},[_vm._v(_vm._s(_vm.$t(item.title)))])])],2)]})],2)])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})])}
var toggleGame_staticRenderFns = []
var toggleGame_esExports = { render: toggleGame_render, staticRenderFns: toggleGame_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_toggleGame = (toggleGame_esExports);
// CONCATENATED MODULE: ./src/components/toggleGame/index.vue
function toggleGame_injectStyle (ssrContext) {
  __webpack_require__("mUw0")
}
var toggleGame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toggleGame___vue_template_functional__ = false
/* styles */
var toggleGame___vue_styles__ = toggleGame_injectStyle
/* scopeId */
var toggleGame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toggleGame___vue_module_identifier__ = null
var toggleGame_Component = toggleGame_normalizeComponent(
  components_toggleGame,
  selectortype_template_index_0_src_components_toggleGame,
  toggleGame___vue_template_functional__,
  toggleGame___vue_styles__,
  toggleGame___vue_scopeId__,
  toggleGame___vue_module_identifier__
)

/* harmony default export */ var src_components_toggleGame = (toggleGame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/drawer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var drawer = ({
  name: 'drawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    showMode: {
      type: String,
      default: 'overlay'
    },
    drawerStyle: Object
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }
      if (this.showMode === 'overlay') {
        return;
      }
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.placement === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  methods: {
    hideMask: function hideMask() {
      this.$emit('update:show', false);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/drawer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_drawer = ({
  name: 'drawer',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    showMode: {
      type: String,
      default: 'overlay'
    },
    drawerStyle: Object
  },
  data: function data() {
    return {
      drawerWidth: 0,
      translateX: 0
    };
  },

  watch: {
    show: function show() {
      if (!this.show) {
        this.$emit('on-hide');
      } else {
        this.$emit('on-show');
      }
      if (this.showMode === 'overlay') {
        return;
      }
      if (!this.show) {
        this.translateX = 0;
      } else {
        this.translateX = this.placement === 'left' ? this.drawerWidth : -this.drawerWidth;
      }
    }
  },
  methods: {
    hideMask: function hideMask() {
      this.$emit('update:show', false);
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.drawerWidth = this.$refs.drawer.clientWidth;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c146b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/drawer/index.vue
var drawer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-drawer"},[_c('div',{staticClass:"vux-drawer-body",style:({transform: ("translate3d(" + _vm.translateX + "px, 0, 0)")})},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"drawer-mask",class:_vm.show ? 'vux-drawer-active' : '',on:{"click":_vm.hideMask}})],2),_vm._v(" "),_c('div',{ref:"drawer",staticClass:"vux-drawer-content",class:[_vm.placement !=='left' ? 'drawer-right' : 'drawer-left', _vm.show ? 'vux-drawer-active' : ''],style:(_vm.drawerStyle)},[_vm._t("drawer")],2)])}
var drawer_staticRenderFns = []
var drawer_esExports = { render: drawer_render, staticRenderFns: drawer_staticRenderFns }
/* harmony default export */ var src_components_drawer = (drawer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/drawer/index.vue
function drawer_injectStyle (ssrContext) {
  __webpack_require__("tH2/")
}
var drawer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var drawer___vue_template_functional__ = false
/* styles */
var drawer___vue_styles__ = drawer_injectStyle
/* scopeId */
var drawer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var drawer___vue_module_identifier__ = null
var drawer_Component = drawer_normalizeComponent(
  components_drawer,
  src_components_drawer,
  drawer___vue_template_functional__,
  drawer___vue_styles__,
  drawer___vue_scopeId__,
  drawer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_drawer = (drawer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var flexbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var flexbox_staticRenderFns = []
var flexbox_esExports = { render: flexbox_render, staticRenderFns: flexbox_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (flexbox_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function flexbox_injectStyle (ssrContext) {
  __webpack_require__("Bf+Z")
}
var flexbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox___vue_template_functional__ = false
/* styles */
var flexbox___vue_styles__ = flexbox_injectStyle
/* scopeId */
var flexbox___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox___vue_module_identifier__ = null
var flexbox_Component = flexbox_normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  flexbox___vue_template_functional__,
  flexbox___vue_styles__,
  flexbox___vue_scopeId__,
  flexbox___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = (flexbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var flexbox_item_staticRenderFns = []
var flexbox_item_esExports = { render: flexbox_item_render, staticRenderFns: flexbox_item_staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (flexbox_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var flexbox_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var flexbox_item___vue_template_functional__ = false
/* styles */
var flexbox_item___vue_styles__ = null
/* scopeId */
var flexbox_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var flexbox_item___vue_module_identifier__ = null
var flexbox_item_Component = flexbox_item_normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  flexbox_item___vue_template_functional__,
  flexbox_item___vue_styles__,
  flexbox_item___vue_scopeId__,
  flexbox_item___vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = (flexbox_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FullScreenRotation/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var FullScreenRotation = ({
  props: ["index"],
  data: function data() {
    var _this = this;

    return {
      swiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function () {
            for (var i = 0; i < this.bannerList.length; i++) {
              this.$refs["videoPlayer" + i][0].pause();
            }
          }.bind(this),
          slidePrevTransitionEnd: function slidePrevTransitionEnd() {
            _this.autoPlayVideo();
          },
          slideNextTransitionEnd: function slideNextTransitionEnd() {
            _this.autoPlayVideo();
          }
        }
      },
      bannerListPc: [{
        videoSource: __webpack_require__("WbPu"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("WX8O"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("Wjw9"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("3hqR"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("AOxs"),
        name: "niuniu"
      }],
      bannerListMobli: [{
        videoSource: __webpack_require__("Kdb+"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("s6er"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("+ZNz"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("a4fN"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("7tfa"),
        name: "niuniu"
      }],
      bannerList: [{
        videoSource: __webpack_require__("WbPu"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("WX8O"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("Wjw9"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("3hqR"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("AOxs"),
        name: "niuniu"
      }]
    };
  },

  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  methods: {
    autoPlayVideo: function autoPlayVideo() {
      var _this2 = this;

      var videoIndex = null;
      if (this.$refs.videoSwiper.swiper) {
        videoIndex = this.$refs.videoSwiper.swiper.realIndex;
      }
      if (videoIndex != null) {
        this.$nextTick(function () {
          if (_this2.$refs["videoPlayer" + videoIndex].length > 0) {
            _this2.$refs["videoPlayer" + videoIndex][0].play();
          }
        });
      }
    },
    toggleVideo: function toggleVideo() {
      if (window.innerWidth > 700) {
        this.bannerList = this.bannerListPc;
      } else {
        this.bannerList = this.bannerListMobli;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.toggleVideo();
    this.$refs.videoSwiper.swiper.slideTo(this.index);
    this.$nextTick(function () {
      if (_this3.$refs["videoPlayer" + _this3.index].length > 0) {
        _this3.$refs["videoPlayer" + _this3.index][0].play();
      }
    });
    window.onresize = function () {
      _this3.toggleVideo();
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FullScreenRotation/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_FullScreenRotation = ({
  props: ["index"],
  data: function data() {
    var _this = this;

    return {
      swiperOption: {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          slideChange: function () {
            for (var i = 0; i < this.bannerList.length; i++) {
              this.$refs["videoPlayer" + i][0].pause();
            }
          }.bind(this),
          slidePrevTransitionEnd: function slidePrevTransitionEnd() {
            _this.autoPlayVideo();
          },
          slideNextTransitionEnd: function slideNextTransitionEnd() {
            _this.autoPlayVideo();
          }
        }
      },
      bannerListPc: [{
        videoSource: __webpack_require__("WbPu"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("WX8O"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("Wjw9"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("3hqR"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("AOxs"),
        name: "niuniu"
      }],
      bannerListMobli: [{
        videoSource: __webpack_require__("Kdb+"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("s6er"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("+ZNz"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("a4fN"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("7tfa"),
        name: "niuniu"
      }],
      bannerList: [{
        videoSource: __webpack_require__("WbPu"),
        name: "baijiale"
      }, {
        videoSource: __webpack_require__("WX8O"),
        name: "lunpan"
      }, {
        videoSource: __webpack_require__("Wjw9"),
        name: "buyu"
      }, {
        videoSource: __webpack_require__("3hqR"),
        name: "zhajinhua"
      }, {
        videoSource: __webpack_require__("AOxs"),
        name: "niuniu"
      }]
    };
  },

  components: {
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },
  methods: {
    autoPlayVideo: function autoPlayVideo() {
      var _this2 = this;

      var videoIndex = null;
      if (this.$refs.videoSwiper.swiper) {
        videoIndex = this.$refs.videoSwiper.swiper.realIndex;
      }
      if (videoIndex != null) {
        this.$nextTick(function () {
          if (_this2.$refs["videoPlayer" + videoIndex].length > 0) {
            _this2.$refs["videoPlayer" + videoIndex][0].play();
          }
        });
      }
    },
    toggleVideo: function toggleVideo() {
      if (window.innerWidth > 700) {
        this.bannerList = this.bannerListPc;
      } else {
        this.bannerList = this.bannerListMobli;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.toggleVideo();
    this.$refs.videoSwiper.swiper.slideTo(this.index);
    this.$nextTick(function () {
      if (_this3.$refs["videoPlayer" + _this3.index].length > 0) {
        _this3.$refs["videoPlayer" + _this3.index][0].play();
      }
    });
    window.onresize = function () {
      _this3.toggleVideo();
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94f94cd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullScreenRotation/index.vue
var FullScreenRotation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-page-rotation"},[_c('swiper',{ref:"videoSwiper",staticClass:"full-page-swiper",attrs:{"options":_vm.swiperOption}},[_vm._l((_vm.bannerList),function(item,index){return _c('swiper-slide',{key:index,staticClass:"video-wrap"},[_c('video',{ref:"videoPlayer"+index,refInFor:true,attrs:{"loop":"loop","controls":"controls","playsinline":""}},[_c('source',{attrs:{"type":"video/mp4","src":item.videoSource}})])])})],2),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev",attrs:{"slot":"button-prev"},slot:"button-prev"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next",attrs:{"slot":"button-next"},slot:"button-next"})],1)}
var FullScreenRotation_staticRenderFns = []
var FullScreenRotation_esExports = { render: FullScreenRotation_render, staticRenderFns: FullScreenRotation_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_FullScreenRotation = (FullScreenRotation_esExports);
// CONCATENATED MODULE: ./src/components/FullScreenRotation/index.vue
function FullScreenRotation_injectStyle (ssrContext) {
  __webpack_require__("m4ou")
}
var FullScreenRotation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var FullScreenRotation___vue_template_functional__ = false
/* styles */
var FullScreenRotation___vue_styles__ = FullScreenRotation_injectStyle
/* scopeId */
var FullScreenRotation___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var FullScreenRotation___vue_module_identifier__ = null
var FullScreenRotation_Component = FullScreenRotation_normalizeComponent(
  components_FullScreenRotation,
  selectortype_template_index_0_src_components_FullScreenRotation,
  FullScreenRotation___vue_template_functional__,
  FullScreenRotation___vue_styles__,
  FullScreenRotation___vue_scopeId__,
  FullScreenRotation___vue_module_identifier__
)

/* harmony default export */ var src_components_FullScreenRotation = (FullScreenRotation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/modalFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var modalFrame = ({
  props: ["index"],
  data: function data() {
    return {};
  },

  methods: {
    closeModal: function closeModal() {
      //   alert(1);
      this.$emit("modalFrameClick", false);
      this.$store.dispatch("showHeader", true);
    },
    hiddenModal: function hiddenModal() {
      this.closeModal();
    }
  },
  components: {
    FullScreenRotation: src_components_FullScreenRotation
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.modalWrapOut.addEventListener("click", function (e) {
      var str = e.target.className;
      if (window.innerWidth > 700) {
        if (str.includes("lg-outer")) {
          _this.closeModal();
        }
      } else {
        if (str.includes("lg-inner")) {
          // alert(12);
          _this.closeModal();
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/modalFrame.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Home_modalFrame = ({
  props: ["index"],
  data: function data() {
    return {};
  },

  methods: {
    closeModal: function closeModal() {
      //   alert(1);
      this.$emit("modalFrameClick", false);
      this.$store.dispatch("showHeader", true);
    },
    hiddenModal: function hiddenModal() {
      this.closeModal();
    }
  },
  components: {
    FullScreenRotation: src_components_FullScreenRotation
  },
  mounted: function mounted() {
    var _this = this;

    this.$refs.modalWrapOut.addEventListener("click", function (e) {
      var str = e.target.className;
      if (window.innerWidth > 700) {
        if (str.includes("lg-outer")) {
          _this.closeModal();
        }
      } else {
        if (str.includes("lg-inner")) {
          // alert(12);
          _this.closeModal();
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cb1ab8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/modalFrame.vue
var modalFrame_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-page"},[_c('div',{staticClass:"lg-backdrop in",staticStyle:{"transition-duration":"150ms"}}),_vm._v(" "),_c('div',{ref:"modalWrapOut",staticClass:"lg-outer lg-start-zoom lg-use-css3 lg-css3 lg-slide lg-grab lg-show-after-load lg-hide-download lg-visible lg-hide-items"},[_c('div',{staticClass:"lg",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{staticClass:"lg-inner",staticStyle:{"transition-timing-function":"ease","transition-duration":"600ms"}},[_c('div',{staticClass:"lg-item lg-next-slide lg-prev-slide lg-loaded lg-current lg-complete"},[_c('div',{staticClass:"lg-video-cont"},[_c('FullScreenRotation',{attrs:{"index":_vm.index}})],1)])]),_vm._v(" "),_c('div',{staticClass:"lg-toolbar lg-group"},[_c('span',{staticClass:"lg-close lg-icon",on:{"click":_vm.closeModal}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"lg-sub-html lg-empty-html"})])])])}
var modalFrame_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lg-counter"}},[_c('span',{attrs:{"id":"lg-counter-current"}},[_vm._v("1")]),_vm._v(" / "),_c('span',{attrs:{"id":"lg-counter-all"}},[_vm._v("13")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg-actions"},[_c('div',{staticClass:"lg-prev lg-icon"}),_vm._v(" "),_c('div',{staticClass:"lg-next lg-icon"})])}]
var modalFrame_esExports = { render: modalFrame_render, staticRenderFns: modalFrame_staticRenderFns }
/* harmony default export */ var views_Home_modalFrame = (modalFrame_esExports);
// CONCATENATED MODULE: ./src/views/Home/modalFrame.vue
function modalFrame_injectStyle (ssrContext) {
  __webpack_require__("yxlL")
}
var modalFrame_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var modalFrame___vue_template_functional__ = false
/* styles */
var modalFrame___vue_styles__ = modalFrame_injectStyle
/* scopeId */
var modalFrame___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var modalFrame___vue_module_identifier__ = null
var modalFrame_Component = modalFrame_normalizeComponent(
  Home_modalFrame,
  views_Home_modalFrame,
  modalFrame___vue_template_functional__,
  modalFrame___vue_styles__,
  modalFrame___vue_scopeId__,
  modalFrame___vue_module_identifier__
)

/* harmony default export */ var src_views_Home_modalFrame = (modalFrame_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/index.vue











/* harmony default export */ var Home = ({
  components: {
    Thumbnail: src_components_Thumbnail,
    Drawer: vux_src_components_drawer,

    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    ToggleGame: src_components_toggleGame,
    ModalFrame: src_views_Home_modalFrame
  },
  props: {
    op88888: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      notSupportBGV: false,
      videoIndex: 0,
      showModal: false,
      entryUrl: document.location.href,
      scrollBox: null,
      swiperItemIndex: 0,
      noteActives: 0,
      noticeList: [],
      bannerList: [],
      mode: false,
      gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
      zhBanner: [{
        picUrl: "/static/image/moreyx_1.png",
        className: "list1",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_2.png",
        className: "list2",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_3.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_4.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_5.png",
        className: "list1",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_6.png",
        className: "list2",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_7.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_8.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_9.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_10.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }],
      zhBannerImg: ["/static/img/banner1.png", "/static/img/banner2.png", "/static/img/banner3.png", "/static/img/banner4.png"],
      taiwanBannerImg: ["/static/taiwan/banner1.png", "/static/taiwan/banner2.png", "/static/taiwan/banner3.png", "/static/taiwan/banner4.png"],
      mobileImgList: ["/static/m-img/banner1.png", "/static/m-img/banner2.png", "/static/m-img/banner3.png", "/static/m-img/banner4.png"],
      taiwanMobileImgList: ["/static/m-img/taiwan/banner1.png", "/static/m-img/taiwan/banner2.png", "/static/m-img/taiwan/banner3.png", "/static/m-img/taiwan/banner4.png"],
      videoWebObj: {

        video: __webpack_require__("bDQm"),
        source: __webpack_require__("bDQm")
      }

    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  watch: {
    isMobile: function isMobile(v) {
      this.bannerChange();
    },
    lang: function lang(v) {
      this.bannerChange();
    }
  },
  created: function created() {
    var ua = String(window.navigator.userAgent).toLowerCase();

    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
      this.notSupportBGV = true;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.bannerChange();
    window.onresize = function () {
      if (window.innerWidth > 700) {
        _this.videoWebObj.video = __webpack_require__("bDQm");
        _this.videoWebObj.source = __webpack_require__("bDQm");
      } else {
        _this.videoWebObj.video = __webpack_require__("jZMx");
        _this.videoWebObj.source = __webpack_require__("jZMx");
      }
    };
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    handleOpenGame: function handleOpenGame(type) {

      if (type === 1) {
        window.open("https://api.gcpadi.com/api/trial");
      } else {
        window.open("https://api.gcpadi.com/api/trial");
      }
    },
    handleModalFrameClick: function handleModalFrameClick(bool, index) {
      this.handleShowModal(bool, index);
    },
    handleShowModal: function handleShowModal(bool, index) {
      this.showModal = bool;
      this.videoIndex = index;
      this.$store.dispatch("showHeader", false);
    },
    bannerChange: function bannerChange() {
      var isMobile = this.$store.state.app.isMobile;
      var lang = this.$store.state.app.lang;
      if (isMobile) {
        switch (lang) {
          case "zh-CN":
            this.bannerList = this.mobileImgList;
            break;
          case "taiwan":
            this.bannerList = this.taiwanMobileImgList;
            break;
        }
      } else {
        switch (lang) {
          case "zh-CN":
            this.bannerList = this.zhBannerImg;
            break;
          case "taiwan":
            this.bannerList = this.taiwanBannerImg;
            break;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home/index.vue











/* harmony default export */ var views_Home = ({
  components: {
    Thumbnail: src_components_Thumbnail,
    Drawer: vux_src_components_drawer,

    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    ToggleGame: src_components_toggleGame,
    ModalFrame: src_views_Home_modalFrame
  },
  props: {
    op88888: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      notSupportBGV: false,
      videoIndex: 0,
      showModal: false,
      entryUrl: document.location.href,
      scrollBox: null,
      swiperItemIndex: 0,
      noteActives: 0,
      noticeList: [],
      bannerList: [],
      mode: false,
      gameKindList: ["棋牌类", "电子游戏", "麻将类", "捕猎类"],
      zhBanner: [{
        picUrl: "/static/image/moreyx_1.png",
        className: "list1",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_2.png",
        className: "list2",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_3.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_4.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_5.png",
        className: "list1",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_6.png",
        className: "list2",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_7.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_8.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_9.png",
        className: "list3",
        url: " https://api.gcpadi.com/api/trial"
      }, {
        picUrl: "/static/image/moreyx_10.png",
        className: "list4",
        url: " https://api.gcpadi.com/api/trial"
      }],
      zhBannerImg: ["/static/img/banner1.png", "/static/img/banner2.png", "/static/img/banner3.png", "/static/img/banner4.png"],
      taiwanBannerImg: ["/static/taiwan/banner1.png", "/static/taiwan/banner2.png", "/static/taiwan/banner3.png", "/static/taiwan/banner4.png"],
      mobileImgList: ["/static/m-img/banner1.png", "/static/m-img/banner2.png", "/static/m-img/banner3.png", "/static/m-img/banner4.png"],
      taiwanMobileImgList: ["/static/m-img/taiwan/banner1.png", "/static/m-img/taiwan/banner2.png", "/static/m-img/taiwan/banner3.png", "/static/m-img/taiwan/banner4.png"],
      videoWebObj: {

        video: __webpack_require__("bDQm"),
        source: __webpack_require__("bDQm")
      }

    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  })),
  watch: {
    isMobile: function isMobile(v) {
      this.bannerChange();
    },
    lang: function lang(v) {
      this.bannerChange();
    }
  },
  created: function created() {
    var ua = String(window.navigator.userAgent).toLowerCase();

    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
      this.notSupportBGV = true;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.bannerChange();
    window.onresize = function () {
      if (window.innerWidth > 700) {
        _this.videoWebObj.video = __webpack_require__("bDQm");
        _this.videoWebObj.source = __webpack_require__("bDQm");
      } else {
        _this.videoWebObj.video = __webpack_require__("jZMx");
        _this.videoWebObj.source = __webpack_require__("jZMx");
      }
    };
  },
  beforeDestroy: function beforeDestroy() {},

  methods: {
    handleOpenGame: function handleOpenGame(type) {

      if (type === 1) {
        window.open("https://api.gcpadi.com/api/trial");
      } else {
        window.open("https://api.gcpadi.com/api/trial");
      }
    },
    handleModalFrameClick: function handleModalFrameClick(bool, index) {
      this.handleShowModal(bool, index);
    },
    handleShowModal: function handleShowModal(bool, index) {
      this.showModal = bool;
      this.videoIndex = index;
      this.$store.dispatch("showHeader", false);
    },
    bannerChange: function bannerChange() {
      var isMobile = this.$store.state.app.isMobile;
      var lang = this.$store.state.app.lang;
      if (isMobile) {
        switch (lang) {
          case "zh-CN":
            this.bannerList = this.mobileImgList;
            break;
          case "taiwan":
            this.bannerList = this.taiwanMobileImgList;
            break;
        }
      } else {
        switch (lang) {
          case "zh-CN":
            this.bannerList = this.zhBannerImg;
            break;
          case "taiwan":
            this.bannerList = this.taiwanBannerImg;
            break;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34723e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/index.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-page"},[_c('div',{staticClass:"home-box",attrs:{"id":"element"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"header_video_box"},[_c('div',{staticClass:"con-word-wrap"},[_c('span',{staticClass:"web-title font-gradation"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.webTitle")))]),_vm._v(" "),_c('div',{staticClass:"cont_center pc-cont_center"},[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleOpenGame(1)}}},[_c('span',{staticClass:"yellow_btn"},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.gameTry1")))])])])])]),_vm._v(" "),(_vm.notSupportBGV)?_c('img',{staticClass:"header_video_gif",attrs:{"src":__webpack_require__("uWI9")}}):_c('div',{staticClass:"header_video"},[_c('video',{attrs:{"autoplay":"autoplay","loop":"loop","muted":"muted","id":"headerVideo"},domProps:{"muted":true}},[_c('source',{attrs:{"type":"video/mp4","src":_vm.videoWebObj.source}})])])]),_vm._v(" "),_c('div',{staticClass:"carou"},[_c('Thumbnail',{on:{"modalClick":_vm.handleShowModal}}),_vm._v(" "),_c('span',{staticClass:"game-effect font-gradation"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.bannerExplain")))])],1),_vm._v(" "),_c('div',{staticClass:"cont_center m-cont_center"},[_c('a',{attrs:{"href":"javascript::void(0)"},on:{"click":function($event){return _vm.handleOpenGame(1)}}},[_c('span',{staticClass:"yellow_btn"},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("indexPagePlay.gameTry1")))])])])]),_vm._v(" "),_c('div',{staticClass:"ourAdvantage",attrs:{"id":"ourAdvantage"}},[_c('div',{staticClass:"tryPlay-title"},[_c('span',{staticClass:"advan-title font-gradation"},[_vm._v(_vm._s(_vm.$t("menu.ourAdvantage")))])]),_vm._v(" "),_c('div',{staticClass:"pc-advantage"},[_c('ul',{staticClass:"ad-introduce clearfix"},[_c('li',[_c('div',{staticClass:"introduce-img icon_youshi1"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title1")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content1")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi2"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title2")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content2")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi3"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title3")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content3")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi4"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title4")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content4")))])])])]),_vm._v(" "),_c('ul',{staticClass:"ad-introduce clearfix"},[_c('li',[_c('div',{staticClass:"introduce-img icon_youshi5"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title5")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content5")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi6"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title6")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content6")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi7"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title7")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content7")))])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"introduce-img icon_youshi8"}),_vm._v(" "),_c('div',{staticClass:"ad-word-wrap"},[_c('span',{staticClass:"h5 font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.title8")))]),_vm._v(" "),_c('span',{staticClass:"p font-gradation"},[_vm._v(_vm._s(_vm.$t("ourAdvantage.content8")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"aboutUs",attrs:{"id":"aboutUs"}},[_c('div',{staticClass:"tryPlay-title"},[_c('span',{staticClass:"advan-title font-gradation"},[_vm._v(_vm._s(_vm.$t("menu.aboutUs")))])]),_vm._v(" "),_c('div',{staticClass:"aboutUs-word"},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("aboutUs.p1")))]),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("aboutUs.p2")))]),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("aboutUs.p3")))]),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t("aboutUs.p4")))])])]),_vm._v(" "),_c('div',{staticClass:"more-game"},[_c('div',{staticClass:"tryPlay-title"},[_c('span',{staticClass:"advan-title font-gradation"},[_vm._v(_vm._s(_vm.$t("aboutUs.moreGameTitle")))])]),_vm._v(" "),_c('div',{staticClass:"manyGame-wrap"},[_c('toggle-game')],1)]),_vm._v(" "),(!_vm.op88888)?_c('div',{staticClass:"linkUs",attrs:{"id":"linkUs"}},[_c('div',{staticClass:"tryPlay-title"},[_c('span',{staticClass:"advan-title font-gradation"},[_vm._v(_vm._s(_vm.$t("menu.linkUs")))])]),_vm._v(" "),_vm._m(1)]):_vm._e()]),_vm._v(" "),(_vm.showModal)?_c('ModalFrame',{attrs:{"index":_vm.videoIndex},on:{"modalFrameClick":_vm.handleModalFrameClick}}):_vm._e()],1)}
var Home_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paralax_box"},[_c('div',{staticClass:"layer1"}),_vm._v(" "),_c('div',{staticClass:"layer2"}),_vm._v(" "),_c('div',{staticClass:"layer3"}),_vm._v(" "),_c('div',{staticClass:"layer4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"linkUs-info-ul"},[_c('li',[_c('i',{staticClass:"i-skype"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("Skype:Baison_poker")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"i-tel"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("Tel:+639778877777")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"i-telegram"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("Telegram:bspkf001")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"i-telegram"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("Telegram:baison8888")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"i-whatsapp"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("WhatsApp:+639778877777")])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"i-email"}),_vm._v(" "),_c('span',{staticClass:"font-gradation"},[_vm._v("E-mail:baisonpoker@gmail.com")])])])}]
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/views/Home/index.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("9vEd")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  views_Home,
  selectortype_template_index_0_src_views_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_views_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '*',
    name: 'Home',
    component: src_views_Home
  }]
}));
// CONCATENATED MODULE: ./src/lang/zh.js
/* harmony default export */ var zh = ({
	LaunchedMonth: {
		1: '1月上线',
		2: '2月上线',
		3: '3月上线',
		4: '4月上线',
		5: '5月上线',
		6: '6月上线',
		7: '7月上线',
		8: '8月上线',
		9: '9月上线',
		10: '10月上线',
		11: '11月上线',
		12: '12月上线',
		13: '即将上线'
	},
	menu: {
		home: '首页',
		hotGame: '热门游戏',
		tryPlay: '游戏试玩',
		ourAdvantage: '我们的优势',
		aboutUs: '关于我们',
		linkUs: '联系我们',
		login: '登录',
		register: '注册'
	},
	indexPagePlay: {
		players: '在线玩家：129003',
		webTitle: '全球最顶尖的游戏开发商',
		gameTry1: '游戏试玩',
		gameTry2: '游戏试玩',
		bannerExplain: '纯3D引擎打造极致3D效果，身临其境如同现实博弈  海量游戏集成，为您量身定制，后续不断更新',
		inGame: '进入游戏',
		development: '开发中,敬请期待'
	},
	banner: {
		coming: '敬请期待',
		baijiale: '百家乐',
		lunpan: '欧式轮盘',
		buyu: '3D千炮捕鱼王',
		zhanjinhua: '炸金花',
		niuniu: '抢庄牛牛',
		tuiTongzi: '百人推筒子',
		longhu: '龙虎斗',
		dezhou: '德州扑克',
		jisuhua: '极速炸金花',
		shisanshui: '十三水',
		// runFast: '跑得快',
		paijiu: '通比牌九',
		// doudizhu: '斗地主',
		kingOfFishing3D: '捕鱼王中王',
		shidianban: '十点半',
		sangong: '三公',
		ershiyidian: '二十一点',
		bairenbaijiale: '百人百家乐',
		honghei: '红黑大战',
		niuniu4: '看牌抢庄牛牛',
		bairenniuniu: '百人牛牛',
		benzAndBMW: '奔驰宝马',
		majiangxueliu: '麻将（血流）',
		forestParty: '森林舞会',
		majiangxuezhan: '麻将（血战）',
		landlord: '斗地主（不洗牌）',
		jinsaPoker: '金沙扑克',
		fanbeimajiang: '翻倍血流',
		pirateFishing: '3D海盗来了',
		mermaidFishing: '3D美人渔',
		dezhou_qz: '德州扑克（前注场）',
		errenmj: '二人麻将',
		ksznn_3d: '3D看四张牛牛',
		qznn_3d: '3D抢庄牛牛',
		ddzjs: '极速斗地主',
		jokerNiuniu: '癞子牛牛',
		lkpy: '李逵劈鱼',
		dntg: '大闹天宫',
		birdingJoy: '捕鸟达人',
		goldenCountry: '黄金国度'
	},
	bannerSmallTitle: {
		baijiale: 'BACCARAT',
		lunpan: 'ROULETTE',
		buyu: 'CANNON FISHING',
		zhanjinhua: 'GOLDEN FLOWER',
		niuniu: 'BANKER NIU NIU',
		tuiTongzi: 'CIRCLE TILES',
		longhu: 'DRAGON&TIGER',
		dezhou: 'TEXAS HOLDEM',
		jisuhua: 'SPEED FLOWER',
		shisanshui: 'THIRTEEN POKER',
		// runFast: 'RUN FAST',
		paijiu: 'PAI GOW',
		// doudizhu: "LANDLORDS",
		kingOfFishing3D: 'KING OF FISHING',
		shidianban: 'TEN POINT HALF',
		sangong: 'THREE FACECARD',
		ershiyidian: 'BLACKJACK',
		bairenbaijiale: 'MULTI-PLAYERS BACCARAT',
		honghei: 'RED & BLACK',
		niuniu4: 'Banker Niu Niu （Cards Shown）',
		bairenniuniu: 'MULTI-PLAYERS NIU-NIU',
		majiangxueliu: 'BLOOD FLOW MAHJONG',
		benzAndBMW: 'BENZ & BMW',
		forestParty: 'FOREST PARTY',
		majiangxuezhan: 'BLOOD STATION MAHJONG',
		landlord: 'LANDLORD（NO SHUFFLE)',
		jinsaPoker: 'JINSA POKER',
		fanbeimajiang: 'DOUBLE BLOOD',
		pirateFishing: '3D PIRATE FISHING',
		mermaidFishing: '3D MERMAID FISHING',
		dezhou_qz: 'TEXAS HOLDEM(ANTE)',
		errenmj: '2 persons mahjong',
		ksznn_3d: '3D FOUR CARDS SHOWN NIUNIU',
		qznn_3d: '3D BANKER NIUNIU',
		ddzjs: 'SPEED LANDLORDS',
		jokerNiuniu: 'JOKER NIUNIU',
		lkpy: 'FISHING KUI LEE',
		dntg: 'MONKEY KING',
		birdingJoy: 'BIRDING JOY',
		goldenCountry: 'GOLDEN COUNTRY'
	},
	ourAdvantage: {
		title1: '万兆光纤接入',
		content1: '高密度光纤连接平台，让用户体验什么叫快如闪电',
		title2: '多层网络保护',
		content2: '高防CDN,云防加速，我们何止是快，我们稳如泰山',
		title3: '快捷API接入',
		content3: '我们提供简单快捷的API接入解决方案，想怎么接就怎么接',
		title4: '3D游戏引领',
		content4: '业内纯3D引擎打造，产品体验畅快，进入即是一场身临其境的完美游戏盛宴',
		title5: '权威机构认证',
		content5: '游戏经权威机构测试漏洞并给予专业认证，运行稳定是我们的宗旨',
		title6: '一号全网通',
		content6: '电脑、IOS、iPad、安卓设备，无障碍的跨平台应用，用户放心下畅快玩',
		title7: '运维经验丰富',
		content7: '10年运营维护经验，获CCIE、CCNP、CCNA认证资格',
		title8: '客服团队专业',
		content8: '7* 24小时专业客服团队，更有资深专业工程师全天候为您提供服务'
	},
	aboutUs: {
		p1: '百胜棋牌是一家专注于棋牌游戏市场的游戏开发商。',
		p2: '我们致力于用最先进的3D技术打造最完美的视听盛宴，带给玩家身临其境般的享受；',
		p3: '我们致力于给玩家带来公平公正，有趣流畅的游戏平台；',
		p4: '我们致力于帮助商户平台提升产品竞争力和用户活跃度，丰富商户平台的运营手段，降低其研发成本。',
		moreGameTitle: '更多游戏，敬请期待',
		gameToggleInfo: '学习先行者，创造自我，超越无我'
	},
	NavTitle: {
		online: '已上线',
		qipaiKind: '棋牌类',
		electronGame: '电子类',
		MahjongKing: '麻将类',
		hunterKing: '捕猎类'
	},
	gameName: {
		online: {
			a: '百家乐',
			b: '欧式轮盘',
			c: '3D千炮捕鱼王',
			d: '炸金花',
			e: '抢庄牛牛',
			f: '百人推筒子',
			g: '龙虎斗',
			h: '德州扑克',
			i: '极速炸金花',
			j: '跑得快',
			k: '十三水',
			l: '通比牌九',
			m: '斗地主',
			n: '捕鱼王中王',
			u: '十点半',
			v: '三公',
			lkpy: '李逵劈鱼',
			dntg: '大闹天宫',
			birdingJoy: '捕鸟达人',
			goldenCountry: '黄金国度'
		},
		qipaiKind: {
			zhajinhua3d: '3D炸金花',
			bairen: '百人推筒子',
			niniu: '通比牛牛',
			tongbi: '通比推筒子',
			paijiu: '抢庄牌九',
			guandao: '掼蛋',
			sangong: '三公',
			jialebipuke: '加勒比扑克',
			ershiyidian: '二十一点',
			paohuzi: '跑胡子',
			shaibao: '骰宝',
			bairenniuniu: '百人牛牛',
			sanzhangpuke: '三张扑克',
			doudizhu1: '极速斗地主',
			doudizhu2: '斗地主（不洗牌）',
			qiangzhuangtuitongzi: '抢庄推筒子',
			shidianban: '十点半',
			jokerNiuniu: '癞子牛牛',
			kszqznn: '看三张抢庄牛牛',
			developGame: '更多游戏'
		},
		electronGame: {
			laohuji: '老虎机',
			senlinwuhui: '森林舞会',
			taiqiudashi: '台球大师',
			benchibaoma: '奔驰宝马',
			shuiguopaidui: '水果派对',
			feiqinzoushou: '飞禽走兽',
			wangzhezuqiu: '王者足球',
			hangjinlunpan: '黄金轮盘',
			xingyunwu: '幸运五',
			developGame: '更多游戏'
		},
		MahjongKing: {
			guangdongmajiang: '广东麻将',
			zhuajimajiang: '抓鸡麻将',
			dongbeimajiang: '东北麻将',
			errenmajiang: '二人麻将',
			xueliumajiang: '血流麻将',
			fanbeimajiang: '翻倍血流',
			taimajiang: '台湾麻将',
			guojimajiang: '国际麻将',
			hangzhoumajiang: '杭州麻将',
			kawufumajiang: '卡五福麻将',
			xuezhanmajiang: '血战麻将',
			fuzhoumajiang: '福州麻将',
			zhongyongmajiang: '中庸麻将'
		},
		hunterKing: {
			buniaolueshou: '捕鸟猎手',
			xingjidazhan: '星际大战',
			xingyunbuyu: '幸运捕鱼',
			developGame: '更多游戏'
		}
	},
	linkUs: {
		title: '敬请留下您的联系方式',
		name: '姓名',
		mail: '邮箱',
		phone: '手机',
		remark: '说明',
		btnTxt: '提交',
		captcha: '验证码',
		messages: {
			noName: '请提供一个称呼,方便客服联系您！',
			noContact: '请提供一个联系方式，邮箱或者电话请填写一个！',
			noRemark: '请说明下您遇到的或者想了解的情况，至少10个字以上！',
			remarkLength: '说明信息的长度不够！',
			mailError: '邮箱格式错误！',
			phoneError: '电话号码格式错误!'
		}
	}
});
// CONCATENATED MODULE: ./src/lang/en.js
/* harmony default export */ var en = ({
    LaunchedMonth: {
        1: 'Launched in January',
        2: 'Launched in February',
        3: 'Launched in March',
        4: 'Launched in April',
        5: 'Launched in May',
        6: 'Launched in June',
        7: 'Launched in July',
        8: 'Launched in August',
        9: 'Launched in September',
        10: 'Launched in October',
        11: 'Launched in November',
        12: 'Launched in December',
        13: 'Soon to go online'
    },
    menu: {
        home: 'Yum Home',
        hotGame: '热门游戏',
        tryPlay: '游戏试玩',
        ourAdvantage: 'Our advantage',
        aboutUs: 'about us',
        linkUs: 'contact us',
        login: '登录',
        register: '注册'
    },
    indexPagePlay: {
        players: ' Online players: 129003',
        webTitle: "The world's top game developer",
        gameTry1: 'Game demo',
        gameTry2: 'Game demo2',
        bannerExplain: 'Pure 3D engine to create the ultimate 3D effect, immersive as the reality game massive game integration, tailored for you, follow- up update',
        inGame: 'Enter the game',
        development: 'stay tuned'
    },
    banner: {
        coming: 'coming soon',
        baijiale: "BACCARAT",
        lunpan: 'ROULETTE',
        buyu: 'CANNON FISHING',
        zhanjinhua: 'GOLDEN FLOWER',
        niuniu: 'BANKER NIU NIU',
        tuiTongzi: 'CIRCLE TILES',
        longhu: 'DRAGON&TIGER',
        dezhou: 'TEXAS HOLDEM',
        jisuhua: 'SPEED FLOWER',
        shisanshui: "THIRTEEN POKER",
        paijiu: 'PAI GOW',
        kingOfFishing3D: 'KING OF FISHING',
        shidianban: 'TEN POINT HALF',
        sangong: 'THREE FACECARD',
        ershiyidian: 'BLACK jack',
        bairenbaijiale: 'MULTI-PLAYERS BACCARAT',
        honghei: 'RED & BLACK',
        niuniu4: 'Banker Niu Niu （Cards Shown）',
        bairenniuniu: 'MULTI-PLAYERS Niu-niu',
        majiangxueliu: 'Blood river mahjong',
        benzAndBMW: ' Benz & BMW',
        forestParty: 'Forest Party',
        majiangxuezhan: 'Bleeding mahjong',
        landlord: 'Landlords(No shuffle)',
        jinsaPoker: 'Jinsa Poker',
        fanbeimajiang: 'DOUBLE BLOOD',
        pirateFishing: '3D PIRATE FISHING',
        mermaidFishing: '3D MERMAID FISHING',
        dezhou_qz: 'TEXAS HOLDEM(ANTE)',
        errenmj: "2 persons mahjong",
        ksznn_3d: "3D FOUR CARDS SHOWN NIUNIU",
        qznn_3d: "3D BANKER NIUNIU",
        ddzjs: "Landlords (rapid)",
        jokerNiuniu: "JOKER NIUNIU",
        kszqznn: "THREE CARDS SHOWN NIUNIU",
        lkpy: 'FISHING KUI LEE',
        dntg: 'MONKEY KING',
        birdingJoy: 'BIRDING JOY',
        goldenCountry: 'GOLDEN COUNTRY'
    },
    ourAdvantage: {
        title1: '10mb fiber access',
        content1: 'High density optical fiber connection platform, let the user experience what is fast as lightning',
        title2: 'Multi-layer network protection',
        content2: 'High CDN, cloud anti-acceleration, we are more than fast, we are as stable as mount tai',
        title3: "Quick API access",
        content3: 'We provide a simple and fast API access solution, how to connect',
        title4: '3D game guidance',
        content4: 'Industry pure 3D engine, product experience is smooth, enter is a perfect immersive game feast',
        title5: 'Certification by authorities',
        content5: 'The game is tested by the authority of the vulnerability and given professional certification, stable operation is our purpose',
        title6: 'All-netcom one',
        content6: 'Computer, IOS, iPad, android devices, barrier-free cross-platform applications, users feel free to play',
        title7: 'Rich experience in operation and maintenance',
        content7: '10 years of operation and maintenance experience, CCIE, CCNP, CCNA certification qualification',
        title8: 'Professional customer service team',
        content8: '7*24 hours professional customer service team'
    },
    aboutUs: {
        p1: 'Yum! Chess is a game developer who focuses on the card market.',
        p2: 'We are committed to creating the perfect audio-visual feast with the most advanced 3D technology, giving players an immersive experience;',
        p3: 'We are committed to bringing fair, just and fun game platforms to our players;',
        p4: 'We are committed to helping merchant platforms enhance product competitiveness and user activity, enrich the operational tools of merchant platforms, and reduce their research and development costs.',
        moreGameTitle: 'More games, stay tuned',
        gameToggleInfo: 'Learn the first mover, create oneself, surpass me'
    },
    NavTitle: {
        online: 'Online',
        qipaiKind: 'Chess',
        electronGame: 'Electronic',
        MahjongKing: 'Mahjong',
        hunterKing: 'Hunting'
    },
    gameName: {
        online: {
            a: 'BACCARAT',
            b: 'ROULETTE',
            c: 'CANNON FISHING',
            d: 'GOLDEN FLOWER',
            e: 'BANKER NIU NIU',
            f: 'CIRCLE TILES',
            g: 'DRAGON&TIGER',
            h: 'TEXAS HOLDEM',
            i: 'SPEED FLOWER',
            j: 'RUN FAST',
            k: 'THIRTEEN POKER',
            l: 'PAI GOW',
            m: 'LANDLORDS',
            n: 'KING OF FISHING(3D)',
            u: 'TEN POINT HALF',
            v: 'THREE FACECARD',
            lkpy: 'FISHING KUI LEE',
            dntg: 'MONKEY KING',
            birdingJoy: 'BIRDING JOY',
            goldenCountry: 'GOLDEN COUNTRY'
        },
        qipaiKind: {
            zhajinhua3d: "3D GOLDEN FLOWER",
            bairen: 'Hundred people push the package',
            niniu: 'Tongbi cattle',
            tongbi: 'Tongbi pusher',
            paijiu: 'Grab the card',
            guandao: "Whipped egg",
            sangong: "THREE FACECARD",
            jialebipuke: "Caribbean Poker",
            ershiyidian: "BLACK JACK",
            paohuzi: "Running beard",
            shaibao: "Sic bo",
            bairenniuniu: "Multiplayer Niu-niu",
            sanzhangpuke: "Three poker",
            doudizhu1: "Landlords (rapid)",
            doudizhu2: "Landlords (no shuffle)",
            qiangzhuangtuitongzi: "Grab the pusher",
            shidianban: 'TEN POINT HALF',
            jokerNiuniu: "JOKER NIUNIU",
            developGame: "more games"
        },
        electronGame: {
            laohuji: "Slot machine",
            senlinwuhui: "Forest dance",
            taiqiudashi: "Billiard master",
            benchibaoma: "Mercedes-Benz BMW",
            shuiguopaidui: "Fruit party",
            feiqinzoushou: "Birds and beasts",
            wangzhezuqiu: "King football",
            hangjinlunpan: "Gold roulette",
            xingyunwu: "Lucky five",
            developGame: "More games"
        },
        MahjongKing: {
            guangdongmajiang: "Guangdong Mahjong",
            zhuajimajiang: "Catching chicken mahjong",
            dongbeimajiang: "Northeast Mahjong",
            errenmajiang: "Two mahjong",
            xueliumajiang: "Blood river mahjong",
            fanbeimajiang: "DOUBLE BLOOD",
            taimajiang: "Taiwan Mahjong",
            guojimajiang: "International mahjong",
            hangzhoumajiang: "Hangzhou Mahjong",
            kawufumajiang: "Card Wufu Mahjong",
            xuezhanmajiang: "Bleeding mahjong",
            fuzhoumajiang: "Fuzhou Mahjong",
            zhongyongmajiang: "Moderate mahjong"
        },
        hunterKing: {
            buniaolueshou: "Bird hunter",
            xingjidazhan: "Star Wars",
            xingyunbuyu: "Lucky fishing",
            developGame: "more games"
        }
    },
    linkUs: {
        title: 'Please leave your contact information',
        name: 'Name',
        mail: 'Mailbox',
        phone: 'Mobile phone',
        remark: 'Description',
        btnTxt: 'submit',
        captcha: 'Verification code',
        messages: {
            noName: 'Please provide a name, convenient customer service contact you!',
            noContact: 'Please provide a contact information, email or telephone number, please fill one!',
            noRemark: 'Please explain the situation you meet or want to know, at least 10 words above!',
            remarkLength: 'Insufficient length of message!',
            mailError: 'Email format error!',
            phoneError: 'Wrong format of phone number!'
        }
    }
});
// CONCATENATED MODULE: ./src/lang/taiwan.js
/* harmony default export */ var taiwan = ({
    LaunchedMonth: {
        1: "1月上線",
        2: "2月上線",
        3: "3月上線",
        4: "4月上線",
        5: "5月上線",
        6: "6月上線",
        7: "7月上線",
        8: "8月上線",
        9: "9月上線",
        10: "10月上線",
        11: "11月上線",
        12: "12月上線",
        13: "即將上線"
    },
    menu: {
        home: "百勝首頁",
        hotGame: "熱門遊戲",
        tryPlay: "遊戲試玩",
        ourAdvantage: "我們的優勢",
        aboutUs: "關於我們",
        linkUs: "聯系我們",
        login: "登錄",
        register: "註冊"
    },
    indexPagePlay: {
        players: "在線玩家：129003",
        webTitle: "全球最頂尖的遊戲開發商",
        gameTry1: "遊戲試玩",
        gameTry2: "遊戲試玩2",
        bannerExplain: "純3D引擎打造極致3D效果，身臨其境如同現實博弈海量遊戲集成，為您量身定制，後續不斷更新",
        inGame: "進入遊戲",
        development: "開發中，敬請期待"
    },
    banner: {
        coming: "敬請期待",
        baijiale: "百家樂",
        lunpan: "歐式輪盤",
        buyu: "3D千炮捕魚王",
        zhanjinhua: "炸金花",
        niuniu: "搶莊牛牛",
        tuiTongzi: "百人推筒子",
        longhu: "龍虎鬥",
        dezhou: "德州撲克",
        jisuhua: "極速炸金花",
        shisanshui: "十三水",
        paijiu: "通比牌九",
        kingOfFishing3D: "捕魚王中王",
        shidianban: "十點半",
        sangong: "三公",
        ershiyidian: "二十壹點",
        bairenbaijiale: "百人百家樂",
        honghei: "紅黑大戰",
        niuniu4: "看牌搶莊牛牛",
        bairenniuniu: "百人牛牛",
        majiangxueliu: "麻將（血流）",
        benzAndBMW: "奔馳寶馬",
        forestParty: "森林舞會",
        majiangxuezhan: "麻將（血戰）",
        landlord: "鬥地主（不洗牌）",
        jinsaPoker: "金沙撲克",
        fanbeimajiang: "翻倍血流",
        pirateFishing: "3D海盜來了",
        mermaidFishing: "3D美人漁",
        dezhou_qz: "德州撲克（前註場）",
        errenmj: "二人麻將",
        ksznn_3d: "3D看四張牛牛",
        qznn_3d: "3D搶莊牛牛",
        ddzjs: "極速鬥地主",
        jokerNiuniu: "癩子牛牛",
        lkpy: '李逵劈魚',
        dntg: '大鬧天宮',
        birdingJoy: '捕鳥達人',
        goldenCountry: '黃金國度'
    },
    bannerSmallTitle: {
        baijiale: "BACCARAT",
        lunpan: "ROULETTE",
        buyu: "CANNON FISHING",
        zhanjinhua: "GOLDEN FLOWER",
        niuniu: "BANKER NIU NIU",
        tuiTongzi: "CIRCLE TILES",
        longhu: "DRAGON&TIGER",
        dezhou: "TEXAS HOLDEM",
        jisuhua: "SPEED FLOWER",
        shisanshui: "THIRTEEN POKER",
        // runFast: 'RUN FAST',
        paijiu: "PAI GOW",
        // doudizhu: "LANDLORDS",
        kingOfFishing3D: "KING OF FISHING",
        shidianban: "TEN POINT HALF",
        sangong: "THREE FACECARD",
        ershiyidian: "BLACKJACK",
        bairenbaijiale: "MULTI-PLAYERS BACCARAT",
        honghei: "RED & BLACK",
        niuniu4: "Banker Niu Niu （Cards Shown）",
        bairenniuniu: "MULTI-PLAYERS NIU-NIU",
        majiangxueliu: "Blood flow mahjong",
        benzAndBMW: " Benz & BMW",
        forestParty: "Forest Party",
        majiangxuezhan: "Blood station mahjong",
        landlord: "Landlords（No shuffle)",
        jinsaPoker: "JinSa Poker",
        fanbeimajiang: "DOUBLE BLOOD",
        pirateFishing: "3D PIRATE FISHING",
        mermaidFishing: "3D MERMAID FISHING",
        dezhou_qz: "TEXAS HOLDEM(ANTE)",
        errenmj: "2 persons mahjong",
        ksznn_3d: "3D FOUR CARDS SHOWN NIUNIU",
        qznn_3d: "3D BANKER NIUNIU",
        ddzjs: "SPEED LANDLORDS",
        jokerNiuniu: "JOKER NIUNIU",
        lkpy: 'FISHING KUI LEE',
        dntg: 'MONKEY KING',
        birdingJoy: 'BIRDING JOY',
        goldenCountry: 'GOLDEN COUNTRY'
    },
    ourAdvantage: {
        title1: "萬兆光纖接入",
        content1: "高密度光纖連接平臺，讓用戶體驗什麽叫快如閃電",
        title2: "多層網絡保護",
        content2: "高防CDN,雲防加速，我們何止是快，我們穩如泰山",
        title3: "快捷api接入",
        content3: "我們提供簡單快捷的api接入解決方案，想怎麽接就怎麽接",
        title4: "3D遊戲引領",
        content4: "業內純3D引擎打造，產品體驗暢快，進入即是壹場身臨其境的完美遊戲盛宴",
        title5: "權威機構認證 ",
        content5: "遊戲經權威機構測試漏洞並給予專業認證，運行穩定是我們的宗旨",
        title6: "壹號全網通",
        content6: "電腦、IOS、iPad、安卓設備，無障礙的跨平臺應用，用戶放心下暢快玩",
        title7: "運維經驗豐富",
        content7: "10年運營維護經驗，獲CCIE、CCNP、CCNA認證資格",
        title8: "客服團隊專業",
        content8: "7*24小時專業客服團隊，更有資深專業工程師全天候為您提供服務"
    },
    NavTitle: {
        online: "已上線",
        qipaiKind: "棋牌类",
        electronGame: "电子类",
        MahjongKing: "麻将类",
        hunterKing: "捕猎类"
    },
    gameName: {
        online: {
            a: "百家樂",
            b: "歐式輪盤",
            c: "3D千炮捕魚王",
            d: "炸金花",
            e: "搶莊牛牛",
            f: "百人推筒子",
            g: "龍虎鬥",
            h: "德州撲克",
            i: "極速炸金花",
            j: "跑得快",
            k: "十三水",
            l: "通比牌九",
            m: "鬥地主",
            n: "3D捕魚王中王",
            u: "十點半",
            v: "三公",
            lkpy: '李逵劈魚',
            dntg: '大鬧天宮',
            birdingJoy: '捕鳥達人',
            goldenCountry: '黃金國度'
        },
        qipaiKind: {
            zhajinhua3d: "3D炸金花",
            bairen: "百人推筒子",
            niniu: "通比牛牛",
            tongbi: "通比推筒子",
            paijiu: "搶莊牌九",
            guandao: "摜蛋",
            sangong: "三公",
            jialebipuke: "加勒比撲克",
            ershiyidian: "二十一點",
            paohuzi: "跑鬍子",
            shaibao: "骰寶",
            bairenniuniu: "百人牛牛",
            sanzhangpuke: "三張撲克",
            doudizhu1: "極速鬥地主",
            doudizhu2: "鬥地主（不洗牌）",
            shidianban: "十點半",
            qiangzhuangtuitongzi: "搶莊推筒子",
            jokerNiuniu: "癩子牛牛",
            kszqznn: "看三張搶莊牛牛",
            developGame: "更多遊戲"
        },
        electronGame: {
            laohuji: "老虎機",
            senlinwuhui: "森林舞會",
            taiqiudashi: "台球大師",
            benchibaoma: "奔馳寶馬",
            shuiguopaidui: "水果派對",
            feiqinzoushou: "飛禽走獸",
            wangzhezuqiu: "王者足球",
            hangjinlunpan: "黃金輪盤",
            xingyunwu: "幸運五",
            developGame: "更多遊戲"
        },
        MahjongKing: {
            guangdongmajiang: "廣東麻將",
            zhuajimajiang: "抓雞麻將",
            dongbeimajiang: "東北麻將",
            errenmajiang: "二人麻将",
            xueliumajiang: "血流麻将",
            fanbeimajiang: "翻倍血流",
            taimajiang: "台灣麻將",
            guojimajiang: "國際麻將",
            hangzhoumajiang: "杭州麻将",
            kawufumajiang: "卡五福麻将",
            xuezhanmajiang: "血戰麻將",
            fuzhoumajiang: "福州麻将",
            zhongyongmajiang: "中庸麻将"
        },
        hunterKing: {
            buniaolueshou: "捕鳥獵手",
            xingjidazhan: "星際大戰",
            xingyunbuyu: "幸運捕魚",
            developGame: "更多遊戲"
        }
    },
    aboutUs: {
        p1: "百勝棋牌是壹家專註於棋牌遊戲市場的遊戲開發商。",
        p2: "我們致力於用最先進的3D技術打造最完美的視聽盛宴，帶給玩家身臨其境般的享受；",
        p3: "我們致力於給玩家帶來公平公正，有趣流暢的遊戲平臺；",
        p4: "我們致力於幫助商戶平臺提升產品競爭力和用戶活躍度，豐富商戶平臺的運營手段，降低其研發成本。",
        moreGameTitle: "更多遊戲，敬請期待",
        gameToggleInfo: "學習先行者，創造自我，超越無我"
    },
    linkUs: {
        title: "敬請留下您的聯系方式",
        name: "姓名",
        mail: "郵箱",
        phone: "手機",
        remark: "說明",
        btnTxt: "提交",
        captcha: "驗證碼",
        messages: {
            noName: "請提供壹個稱呼,方便客服聯系您！",
            noContact: "請提供壹個聯系方式，郵箱或者電話請填寫壹個！",
            noRemark: "請說明下您遇到的或者想了解的情況，至少10個字以上！",
            remarkLength: "說明信息的長度不夠！",
            mailError: "郵箱格式錯誤！",
            phoneError: "電話號碼格式錯誤！"
        }
    }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/utils/auth.js


// const TokenKey = 'cp-token'
var TokenKey = 'cp-token';

function getToken() {
  // return Cookies.get(TokenKey)
  return js_cookie_default.a.get(TokenKey);
}

function setToken(token) {
  return js_cookie_default.a.set(TokenKey, token);
}

function removeToken() {
  return js_cookie_default.a.remove(TokenKey);
}

function isLogin() {
  return getToken() ? true : false;
}
// CONCATENATED MODULE: ./src/store/modules/user.js



var user = {
  state: {
    userInfo: {},
    // token: getToken(),
    token: getToken(),
    account: {},
    defaultAvatar: 'this.src="data:image/jpeg;base64,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"'
  },

  mutations: {
    SET_USER: function SET_USER(state, user) {
      state.userInfo = user;
    },
    SET_ACCOUNT: function SET_ACCOUNT(state, account) {
      state.account = account;
    }
  },
  actions: {
    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref) {
      var commit = _ref.commit;

      return new promise_default.a(function (resolve, reject) {
        // getUserInfo(getToken()).then(response => {          
        //   const data = response.data;
        //   commit('SET_USER', data)
        //   resolve(response)
        // }).catch(error => {
        //   reject(error)
        // })
      });
    },

    // 获取用户余额
    GetUserAccount: function GetUserAccount(_ref2) {
      // getBalance().then(res => {
      //   commit('SET_ACCOUNT', res.data)
      // })

      var commit = _ref2.commit;
    },

    // 前端 登出
    FedLogOut: function FedLogOut(_ref3) {
      var commit = _ref3.commit;

      return new promise_default.a(function (resolve) {
        commit('SET_USER', {});
        removeToken();
        resolve();
      });
    }
  }
};

/* harmony default export */ var modules_user = (user);
// CONCATENATED MODULE: ./src/store/modules/app.js
var app = {
  state: {
    navTitle: '',
    showNavRightBtn: false,
    showNavSetting: false,
    showNavLeftRegBtn: false,
    showNavBack: true,
    headerShowBottomArrow: false,
    navRightBtnHtml: '',
    bodyPaddingBottom: '0.2rem',
    leftBackTxt: '返回',
    isShowHeader: true,
    showNavRightLoginBox: true,
    isMobile: false,
    lang: 'zh-CN',
    rotateVal: false,
    autoHeight: true
  },
  mutations: {
    SET_AUROHEIGHT: function SET_AUROHEIGHT(state, val) {
      state.autoHeight = val;
    },
    SET_NAV_TITLE: function SET_NAV_TITLE(state, title) {
      state.navTitle = title;
    },
    SET_SHOW_NAV_BOTTOM_ARROW: function SET_SHOW_NAV_BOTTOM_ARROW(state, isShow) {
      state.headerShowBottomArrow = isShow;
    },
    SET_NAV_RIGHT_BTN: function SET_NAV_RIGHT_BTN(state, arg) {
      state.showNavRightBtn = arg.showOrHide || false;
      state.navRightBtnHtml = arg.html || '';
    },
    SET_SHOW_NAV_BACK: function SET_SHOW_NAV_BACK(state, arg) {
      state.showNavBack = arg.showOrHide || false;
      state.leftBackTxt = arg.txt || '返回';
    },
    RESET_NAV_BACK: function RESET_NAV_BACK(state) {
      state.showNavBack = true;
      state.leftBackTxt = '返回';
    },
    SET_SHOW_NAV_SETTING: function SET_SHOW_NAV_SETTING(state, showOrHide) {
      state.showNavSetting = showOrHide;
    },
    SET_BODY_PADDING_BOTTOM: function SET_BODY_PADDING_BOTTOM(state, h) {
      state.bodyPaddingBottom = h;
    },
    RESET_BODY_PADDING_BOTTOM: function RESET_BODY_PADDING_BOTTOM(state) {
      state.bodyPaddingBottom = '0.2rem';
    },
    SET_SHOW_NAV_LEFT_REG_BTN: function SET_SHOW_NAV_LEFT_REG_BTN(state, showOrHide) {
      state.showNavLeftRegBtn = showOrHide || false;
    },
    SET_SHOW_HEADER: function SET_SHOW_HEADER(state, showOrHide) {
      state.isShowHeader = showOrHide;
    },
    SHOW_NAV_RIGHT_BTN: function SHOW_NAV_RIGHT_BTN(state, showOrHide) {
      state.showNavRightLoginBox = showOrHide;
    },
    SET_MOBILE: function SET_MOBILE(state, isMobile) {
      state.isMobile = isMobile;
    },
    SET_LANG: function SET_LANG(state, lang) {
      state.lang = lang;
    },
    SET_ROTATE: function SET_ROTATE(state, bool) {
      state.rotateVal = bool;
    }
  },
  actions: {
    setBodyPaddingBottom: function setBodyPaddingBottom(_ref, h) {
      var commit = _ref.commit;

      commit('SET_BODY_PADDING_BOTTOM', h);
    },
    resetBodyPaddingBottom: function resetBodyPaddingBottom(_ref2) {
      var commit = _ref2.commit;

      commit('RESET_BODY_PADDING_BOTTOM');
    },
    setNavTitle: function setNavTitle(_ref3, title) {
      var commit = _ref3.commit;

      document.title = title;
      commit('SET_NAV_TITLE', title);
    },
    setNavRightBtn: function setNavRightBtn(_ref4, arg) {
      var commit = _ref4.commit;

      commit('SET_NAV_RIGHT_BTN', arg);
    },
    setNavBack: function setNavBack(_ref5, arg) {
      var commit = _ref5.commit;

      commit('SET_SHOW_NAV_BACK', arg);
    },
    resetNavBack: function resetNavBack(_ref6) {
      var commit = _ref6.commit;

      commit('RESET_NAV_BACK');
    },
    setNavSetting: function setNavSetting(_ref7, arg) {
      var commit = _ref7.commit;

      commit('SET_SHOW_NAV_SETTING', arg);
    },
    setNavBottomArrow: function setNavBottomArrow(_ref8, arg) {
      var commit = _ref8.commit;

      commit('SET_SHOW_NAV_BOTTOM_ARROW', arg);
    },
    showNavLeftRegBtn: function showNavLeftRegBtn(_ref9, arg) {
      var commit = _ref9.commit;

      commit('SET_SHOW_NAV_LEFT_REG_BTN', arg);
    },
    showHeader: function showHeader(_ref10, arg) {
      var commit = _ref10.commit;

      commit('SET_SHOW_HEADER', arg);
    },
    setShowRightLoginBox: function setShowRightLoginBox(_ref11, arg) {
      var commit = _ref11.commit;

      commit('SHOW_NAV_RIGHT_BTN', arg);
    },
    setMobile: function setMobile(_ref12, arg) {
      var commit = _ref12.commit;

      commit('SET_MOBILE', arg);
    },
    setLang: function setLang(_ref13, arg) {
      var commit = _ref13.commit;

      commit('SET_LANG', arg);
    },
    setRotate: function setRotate(_ref14, arg) {
      var commit = _ref14.commit;

      commit('SET_ROTATE', arg);
    },
    setAutoHeight: function setAutoHeight(_ref15, arg) {
      var commit = _ref15.commit;

      commit('SET_AUROHEIGHT', arg);
    }
  }
};

/* harmony default export */ var modules_app = (app);
// CONCATENATED MODULE: ./src/store/modules/game.js
var game = {
  state: {
    periods: '',
    showBottom: false,
    gameName: '',
    selectNumber: [],
    selectNumberDigit: 0,
    gameInfo: {
      betting: ''
    },
    betResult: {}
  },

  mutations: {
    SET_PERIODS: function SET_PERIODS(state, periods) {
      state.periods = periods;
    },
    SET_SHOW_BOTTOM: function SET_SHOW_BOTTOM(state, isShow) {
      state.showBottom = isShow;
    },
    SET_GAME_NAME: function SET_GAME_NAME(state, name) {
      state.gameName = name;
    },
    RESET_GAME_BOTTOM: function RESET_GAME_BOTTOM(state) {
      state.showBottom = false;
      state.gameName = '';
    },
    SET_GAME_SELECT_NUMBER: function SET_GAME_SELECT_NUMBER(state, _ref) {
      var number = _ref.number,
          digit = _ref.digit;

      state.selectNumber = number;
      state.selectNumberDigit = digit;
    },
    RESET_GAME_SELECT_NUMBER: function RESET_GAME_SELECT_NUMBER(state) {
      state.selectNumber = [];
      state.selectNumberDigit = 0;
    },
    SET_GAME_INFO: function SET_GAME_INFO(state, info) {
      state.gameInfo = info;
    },
    SET_GAME_BET_RESULT: function SET_GAME_BET_RESULT(state, info) {
      state.betResult = info;
    }
  },

  actions: {
    setPeriods: function setPeriods(_ref2, periods) {
      var commit = _ref2.commit;

      commit('SET_PERIODS', periods);
    },
    setGameBottom: function setGameBottom(_ref3, arg) {
      var commit = _ref3.commit;

      commit('SET_SHOW_BOTTOM', arg.isShow || false);
      commit('SET_GAME_NAME', arg.name);
    },
    resetGameBottom: function resetGameBottom(_ref4) {
      var commit = _ref4.commit;

      commit('RESET_GAME_BOTTOM');
    },
    setGameNumber: function setGameNumber(_ref5, _ref6) {
      var commit = _ref5.commit;
      var number = _ref6.number,
          digit = _ref6.digit;

      commit('SET_GAME_SELECT_NUMBER', {
        number: number,
        digit: digit
      });
    },
    resetGameNumber: function resetGameNumber(_ref7) {
      var commit = _ref7.commit;

      commit('RESET_GAME_SELECT_NUMBER');
    },
    setGameInfo: function setGameInfo(_ref8, info) {
      var commit = _ref8.commit;

      commit('SET_GAME_INFO', info);
    },
    setGameBetResult: function setGameBetResult(_ref9, info) {
      var commit = _ref9.commit;

      commit('SET_GAME_BET_RESULT', info);
    }
  }
};

/* harmony default export */ var modules_game = (game);
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/** i18n **/
var store = new vuex_esm["a" /* default */].Store({
  modules: {
    user: modules_user,
    app: modules_app,
    game: modules_game,
    i18n: vuex_i18n_es["a" /* default */].store
  }
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/js-md5/src/md5.js
var md5 = __webpack_require__("NC6I");
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);

// CONCATENATED MODULE: ./src/utils/index.js
function isNull(object) {
  if (object == null || typeof object == "undefined") {
    return true;
  }
  return false;
}

function removeRem() {
  var doc = window.document;
  var docEl = doc.documentElement;
  docEl.removeAttribute('style');
}
/* harmony default export */ var utils = ({
  isIE: function isIE() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    return userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1;
  },
  isMobile: function isMobile() {
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  },
  refreshRem: function refreshRem() {
    var doc = window.document;
    var docEl = doc.documentElement;
    var width = docEl.getBoundingClientRect().width;
    //如果是pc
    if (width > 540) {
      removeRem();
      return;
    }
    if (width > 540) {
      // 最大宽度
      width = 540;
    }
    var rem = width / 3.75; // iPhone6比例
    docEl.style.fontSize = rem + 'px';
    window.__REM__ = rem;
  },
  getParam: function getParam(n, t) {
    var i = new RegExp('(?:^|\\?|#|&)' + n + '=([^&#]*)(?:$|&|#)', 'i'),
        o = i.exec(t || location.href);
    return o ? decodeURIComponent(o[1]) : '';
  },
  getSystemPlatform: function getSystemPlatform() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'iOS';
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 'Android';
    } else {
      return 'PC';
    }
  },
  sum: function sum(arr) {
    var val = void 0;
    if (arr && arr.length == 0) {
      val = 0;
    } else if (arr && arr.length == 1) {
      val = arr[0];
    } else {
      val = parseFloat(arr[0]) + parseFloat(this.sum(arr.slice(1)));
    }
    return Number(val).toFixed(2);
  },
  getWeek: function getWeek(dateString) {
    var date;
    if (isNull(dateString)) {
      date = new Date();
    } else {
      var dateArray = dateString.split("-");
      date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
    }
    return "星期" + "日一二三四五六".charAt(date.getDay());
  },
  getCurrentDate: function getCurrentDate() {
    var now = new Date();
    var year = now.getFullYear(); //年
    var month = now.getMonth() + 1; //月
    var day = now.getDate(); //日
    return year + "-" + month + "-" + day;
  }
});
// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/locale/index.js + 2 modules
var locale = __webpack_require__("R3Rq");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/bus/index.js
var bus = __webpack_require__("Sga9");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js + 1 modules
var toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("6WAn")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var x_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var x_dialog_staticRenderFns = []
var x_dialog_esExports = { render: x_dialog_render, staticRenderFns: x_dialog_staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (x_dialog_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function x_dialog_injectStyle (ssrContext) {
  __webpack_require__("6Erz")
}
var x_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_dialog___vue_template_functional__ = false
/* styles */
var x_dialog___vue_styles__ = x_dialog_injectStyle
/* scopeId */
var x_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_dialog___vue_module_identifier__ = null
var x_dialog_Component = x_dialog_normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  x_dialog___vue_template_functional__,
  x_dialog___vue_styles__,
  x_dialog___vue_scopeId__,
  x_dialog___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (x_dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("PgbK")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("j62E")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myHeader/index.vue











/* harmony default export */ var myHeader = ({
  name: "myHeader",
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    XButton: vux_src_components_x_button,
    Confirm: node_modules_vux_src_components_confirm,
    XHeader: vux_src_components_x_header
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: {
    op88888: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data: function data() {
    return {
      isIE: utils.isIE(),
      showLang: false,
      language: "zh-CN",
      options: [],
      value: ""

    };
  },
  mounted: function mounted() {
    this.language = this.$locale.get();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    rotateIcon: function rotateIcon(state) {
      return state.app.rotateVal;
    }
  })),
  methods: {
    showLangList: function showLangList() {
      this.showLang = !this.showLang;
    },
    handleClickMenu: function handleClickMenu() {
      this.$store.dispatch("setRotate", true);
      this.$emit("menuClick");
    },
    handleChangeLanguage: function handleChangeLanguage(language) {
      this.language = language;
      this.$i18n.set(this.language);
      this.$store.dispatch("setLang", this.language);
      this.$locale.set(this.language);
      this.showLang = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/myHeader/index.vue











/* harmony default export */ var components_myHeader = ({
  name: "myHeader",
  components: {
    Flexbox: src_components_flexbox_flexbox,
    FlexboxItem: src_components_flexbox_flexbox_item,
    XButton: vux_src_components_x_button,
    Confirm: node_modules_vux_src_components_confirm,
    XHeader: vux_src_components_x_header
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: {
    op88888: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  data: function data() {
    return {
      isIE: utils.isIE(),
      showLang: false,
      language: "zh-CN",
      options: [],
      value: ""

    };
  },
  mounted: function mounted() {
    this.language = this.$locale.get();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    rotateIcon: function rotateIcon(state) {
      return state.app.rotateVal;
    }
  })),
  methods: {
    showLangList: function showLangList() {
      this.showLang = !this.showLang;
    },
    handleClickMenu: function handleClickMenu() {
      this.$store.dispatch("setRotate", true);
      this.$emit("menuClick");
    },
    handleChangeLanguage: function handleChangeLanguage(language) {
      this.language = language;
      this.$i18n.set(this.language);
      this.$store.dispatch("setLang", this.language);
      this.$locale.set(this.language);
      this.showLang = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5569903a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHeader/index.vue
var myHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],class:{'head-wrap':true,'ie':_vm.isIE}},[_c('div',{staticClass:"nav-head"},[_c('ul',{staticClass:"nav-list clearfix"},[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#element'),expression:"'#element'"}],attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t('menu.home')))])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#ourAdvantage'),expression:"'#ourAdvantage'"}],attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t('menu.ourAdvantage')))])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#hotGame'),expression:"'#hotGame'"}],attrs:{"href":"javascript:void(0)"}},[_c('img',{staticClass:"logo-img",attrs:{"src":"data:image/png;base64,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"}})])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#aboutUs'),expression:"'#aboutUs'"}],attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t('menu.aboutUs')))])])]),_vm._v(" "),(!_vm.op88888)?_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#linkUs'),expression:"'#linkUs'"}],attrs:{"href":"javascript:void(0)"}},[_c('span',{staticClass:"font-gradation"},[_vm._v(_vm._s(_vm.$t('menu.linkUs')))])])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"translate"},[_c('a',{class:{'rotate180':_vm.showLang,'choose-lang':true},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.showLangList}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[(_vm.language=='en')?_c('span',{staticClass:"icon-lang icon-lang-en"}):_vm._e(),_vm._v(" "),(_vm.language=='zh-CN')?_c('span',{staticClass:"icon-lang icon-lang-cn"}):_vm._e(),_vm._v(" "),(_vm.language=='taiwan')?_c('span',{staticClass:"icon-lang icon-lang-tw"}):_vm._e()]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[(_vm.language=='en')?[_c('span',{staticClass:"font-gradation"},[_vm._v("英文")])]:_vm._e(),_vm._v(" "),(_vm.language=='zh-CN')?[_c('span',{staticClass:"font-gradation"},[_vm._v("中文")])]:_vm._e(),_vm._v(" "),(_vm.language=='taiwan')?[_c('span',{staticClass:"font-gradation"},[_vm._v("繁体")])]:_vm._e()],2)],1)],1)]),_vm._v(" "),(_vm.showLang)?_c('ul',{staticClass:"ul-lang-list pc-ul-lang-list"},[_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('en')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang icon-lang-en"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("英文")])])],1)],1),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('zh-CN')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang icon-lang-cn"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("中文")])])],1)],1),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('taiwan')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang icon-lang-tw"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("繁体")])])],1)],1)]):_vm._e()])]),_vm._v(" "),_c('x-header',{staticClass:"m-nav-head"},[_c('span',{attrs:{"slot":"overwrite-left"},slot:"overwrite-left"},[_c('a',{on:{"click":_vm.handleClickMenu}},[_c('span',{staticClass:"menu-icon",class:{'rotateIconClass': _vm.rotateIcon==true}})])]),_vm._v(" "),_c('img',{staticClass:"logo-img",attrs:{"src":"data:image/png;base64,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"}}),_vm._v(" "),_c('div',{attrs:{"slot":"right"},slot:"right"},[_c('a',{class:{'rotate180':_vm.showLang,'choose-lang':true},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.showLangList}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[(_vm.language=='en')?_c('span',{staticClass:"icon-lang-en"}):_vm._e(),_vm._v(" "),(_vm.language=='zh-CN')?_c('span',{staticClass:"icon-lang-cn"}):_vm._e(),_vm._v(" "),(_vm.language=='taiwan')?_c('span',{staticClass:"icon-lang-tw"}):_vm._e()]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item lang-txt"},[(_vm.language=='en')?[_c('span',{staticClass:"font-gradation"},[_vm._v("英文")])]:_vm._e(),_vm._v(" "),(_vm.language=='zh-CN')?[_c('span',{staticClass:"font-gradation"},[_vm._v("中文")])]:_vm._e(),_vm._v(" "),(_vm.language=='taiwan')?[_c('span',{staticClass:"font-gradation"},[_vm._v("繁体")])]:_vm._e()],2)],1)],1)])]),_vm._v(" "),(_vm.showLang)?_c('ul',{staticClass:"ul-lang-list m-ul-lang-list"},[_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('en')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang-en"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("英文")])])],1)],1),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('zh-CN')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang-cn"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("中文")])])],1)],1),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.handleChangeLanguage('taiwan')}}},[_c('flexbox',[_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"icon-lang-tw"})]),_vm._v(" "),_c('flexbox-item',{staticClass:"lang-flex-item"},[_c('span',{staticClass:"font-gradation"},[_vm._v("繁体")])])],1)],1)]):_vm._e()],1)])}
var myHeader_staticRenderFns = []
var myHeader_esExports = { render: myHeader_render, staticRenderFns: myHeader_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_myHeader = (myHeader_esExports);
// CONCATENATED MODULE: ./src/components/myHeader/index.vue
function myHeader_injectStyle (ssrContext) {
  __webpack_require__("i+fE")
}
var myHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var myHeader___vue_template_functional__ = false
/* styles */
var myHeader___vue_styles__ = myHeader_injectStyle
/* scopeId */
var myHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var myHeader___vue_module_identifier__ = null
var myHeader_Component = myHeader_normalizeComponent(
  components_myHeader,
  selectortype_template_index_0_src_components_myHeader,
  myHeader___vue_template_functional__,
  myHeader___vue_styles__,
  myHeader___vue_scopeId__,
  myHeader___vue_module_identifier__
)

/* harmony default export */ var src_components_myHeader = (myHeader_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-956dfba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",[_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])],{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("KU8+")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var cell_props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("KhNL")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/badge/index.vue
//
//
//
//

/* harmony default export */ var components_badge = ({
  name: 'badge',
  props: {
    text: [String, Number]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcc96ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/badge/index.vue
var badge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['vux-badge', {'vux-badge-dot': typeof _vm.text === 'undefined', 'vux-badge-single': typeof _vm.text !== 'undefined' && _vm.text.toString().length === 1}],domProps:{"textContent":_vm._s(_vm.text)}})}
var badge_staticRenderFns = []
var badge_esExports = { render: badge_render, staticRenderFns: badge_staticRenderFns }
/* harmony default export */ var src_components_badge = (badge_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/badge/index.vue
function badge_injectStyle (ssrContext) {
  __webpack_require__("oR1u")
}
var badge_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var badge___vue_template_functional__ = false
/* styles */
var badge___vue_styles__ = badge_injectStyle
/* scopeId */
var badge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var badge___vue_module_identifier__ = null
var badge_Component = badge_normalizeComponent(
  components_badge,
  src_components_badge,
  badge___vue_template_functional__,
  badge___vue_styles__,
  badge___vue_scopeId__,
  badge___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_badge = (badge_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("MC4m")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1b9a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/actionsheet/index.vue
var actionsheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-actionsheet"},[_c('transition',{attrs:{"name":"vux-actionsheet-mask"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask weui-mask_transparent",on:{"click":_vm.onClickingMask}})]),_vm._v(" "),(_vm.theme === 'android')?_c('div',{staticClass:"weui-skin_android"},[_c('transition',{attrs:{"name":"vux-android-actionsheet"},on:{"after-enter":function($event){return _vm.$emit('on-after-show')},"after-leave":function($event){return _vm.$emit('on-after-hide')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-actionsheet"},[_c('div',{staticClass:"weui-actionsheet__menu"},_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})}),0)])])],1):_c('div',{ref:"iOSMenu",staticClass:"weui-actionsheet",class:{'weui-actionsheet_toggle': _vm.show}},[_c('div',{staticClass:"weui-actionsheet__menu"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",class:("vux-actionsheet-menu-" + (text.type || 'default')),domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})})],2),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"weui-actionsheet__action",on:{"click":function($event){return _vm.emitEvent('on-click-menu', 'cancel')}}},[_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._v(_vm._s(_vm.cancelText || '取消'))])]):_vm._e()])],1)}
var actionsheet_staticRenderFns = []
var actionsheet_esExports = { render: actionsheet_render, staticRenderFns: actionsheet_staticRenderFns }
/* harmony default export */ var src_components_actionsheet = (actionsheet_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/actionsheet/index.vue
function actionsheet_injectStyle (ssrContext) {
  __webpack_require__("JYLN")
}
var actionsheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var actionsheet___vue_template_functional__ = false
/* styles */
var actionsheet___vue_styles__ = actionsheet_injectStyle
/* scopeId */
var actionsheet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var actionsheet___vue_module_identifier__ = null
var actionsheet_Component = actionsheet_normalizeComponent(
  components_actionsheet,
  src_components_actionsheet,
  actionsheet___vue_template_functional__,
  actionsheet___vue_styles__,
  actionsheet___vue_scopeId__,
  actionsheet___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_actionsheet = (actionsheet_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-733b6bff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("ZLAY")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673aa6ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3971d056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("5U0s")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
//
//
//
//
//
//



/* harmony default export */ var tabbar_tabbar = ({
  mounted: function mounted() {
    var _this = this;

    if (false) {
      this.$nextTick(function () {
        var $el = _this.$el;
        var position = window.getComputedStyle($el).position;
        if (position === 'fixed') {
          return;
        } else if (position === 'absolute') {
          if (document.documentElement.offsetHeight !== window.innerHeight) {
            console.warn('[VUX warn] tabbar 定位默认为 absolute，如果你没有使用 100% 布局(view-box)，需要手动设置 style position 为 fixed');
          }
        }
      });
    }
  },

  name: 'tabbar',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    iconClass: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df815522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar.vue
var tabbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tabbar"},[_vm._t("default")],2)}
var tabbar_staticRenderFns = []
var tabbar_esExports = { render: tabbar_render, staticRenderFns: tabbar_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar = (tabbar_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar.vue
function tabbar_injectStyle (ssrContext) {
  __webpack_require__("gXWh")
}
var tabbar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar___vue_template_functional__ = false
/* styles */
var tabbar___vue_styles__ = tabbar_injectStyle
/* scopeId */
var tabbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar___vue_module_identifier__ = null
var tabbar_Component = tabbar_normalizeComponent(
  tabbar_tabbar,
  components_tabbar_tabbar,
  tabbar___vue_template_functional__,
  tabbar___vue_styles__,
  tabbar___vue_scopeId__,
  tabbar___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar = (tabbar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tabbar_tabbar_item = ({
  name: 'tabbar-item',
  components: {
    Badge: vux_src_components_badge
  },
  mounted: function mounted() {
    if (!this.$slots.icon) {
      this.simple = true;
    }
    if (this.$slots['icon-active']) {
      this.hasActiveIcon = true;
    }
  },

  mixins: [multi_items["a" /* childMixin */]],
  props: {
    showDot: {
      type: Boolean,
      default: false
    },
    badge: String,
    link: [String, Object],
    iconClass: String
  },
  computed: {
    isActive: function isActive() {
      return this.$parent.index === this.currentIndex;
    }
  },
  data: function data() {
    return {
      simple: false,
      hasActiveIcon: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fc8f9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-tabbar__item",class:{'weui-bar__item_on': _vm.isActive, 'vux-tabbar-simple': _vm.simple},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onItemClick(true)}}},[(!_vm.simple)?_c('div',{staticClass:"weui-tabbar__icon",class:[_vm.iconClass || _vm.$parent.iconClass, {'vux-reddot': _vm.showDot}]},[(!_vm.simple && !(_vm.hasActiveIcon && _vm.isActive))?_vm._t("icon"):_vm._e(),_vm._v(" "),(!_vm.simple && _vm.hasActiveIcon && _vm.isActive)?_vm._t("icon-active"):_vm._e(),_vm._v(" "),(_vm.badge)?_c('sup',[_c('badge',{attrs:{"text":_vm.badge}})],1):_vm._e()],2):_vm._e(),_vm._v(" "),_c('p',{staticClass:"weui-tabbar__label"},[_vm._t("label")],2)])}
var tabbar_item_staticRenderFns = []
var tabbar_item_esExports = { render: tabbar_item_render, staticRenderFns: tabbar_item_staticRenderFns }
/* harmony default export */ var components_tabbar_tabbar_item = (tabbar_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tabbar/tabbar-item.vue
var tabbar_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tabbar_item___vue_template_functional__ = false
/* styles */
var tabbar_item___vue_styles__ = null
/* scopeId */
var tabbar_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tabbar_item___vue_module_identifier__ = null
var tabbar_item_Component = tabbar_item_normalizeComponent(
  tabbar_tabbar_item,
  components_tabbar_tabbar_item,
  tabbar_item___vue_template_functional__,
  tabbar_item___vue_styles__,
  tabbar_item___vue_scopeId__,
  tabbar_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tabbar_tabbar_item = (tabbar_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var loading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var loading_staticRenderFns = []
var loading_esExports = { render: loading_render, staticRenderFns: loading_staticRenderFns }
/* harmony default export */ var src_components_loading = (loading_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function loading_injectStyle (ssrContext) {
  __webpack_require__("t+oN")
}
var loading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loading___vue_template_functional__ = false
/* styles */
var loading___vue_styles__ = loading_injectStyle
/* scopeId */
var loading___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loading___vue_module_identifier__ = null
var loading_Component = loading_normalizeComponent(
  components_loading,
  src_components_loading,
  loading___vue_template_functional__,
  loading___vue_styles__,
  loading___vue_scopeId__,
  loading___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = (loading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


(function rotate() {
  var orientation = window.orientation;
  var pd = null;
  function createPd() {
    if (document.getElementById("preventTran") === null) {
      var imgData = "data:image/png;base64,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";
      pd = document.createElement("div");
      pd.setAttribute("id", "preventTran");
      pd.style.position = "fixed";
      pd.style.left = "0";
      pd.style.top = "0";
      pd.style.width = "100%";
      pd.style.height = "100%";
      pd.style.overflow = "hidden";
      pd.style.backgroundColor = "#03447C";
      pd.style.textAlign = "center";
      pd.style.zIndex = "99999";
      document.getElementsByTagName("body")[0].appendChild(pd);
      var img = document.createElement("img");
      img.src = imgData;
      pd.appendChild(img);
      img.style.margin = "60px auto 30px";
      var br = document.createElement("br");
      var p = document.createElement("p");
      p.style.width = "100%";
      p.style.height = "auto";
      p.style.fontSize = "22px";
      p.style.color = "#FFF";
      p.style.lineHeight = "34px";
      p.style.textAlign = "center";
      p.innerHTML = "为了体验更好的视觉效果";
      p.appendChild(br);
      p.innerHTML += "请竖屏观看/操作";
      pd.appendChild(p);
    }
  }
  if (orientation == 90 || orientation == -90) {
    if (pd == null && document.getElementById("preventTran") === null) createPd();
    document.getElementById("preventTran").style.display = "block";
  }
  window.onorientationchange = function () {
    if (pd == null && document.getElementById("preventTran") == null) createPd();
    document.getElementById("preventTran").style.display = "none";
    rotate();
  };
})();



















/* harmony default export */ var App = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    Radio: node_modules_vux_src_components_radio,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell,
    Badge: vux_src_components_badge,
    Drawer: vux_src_components_drawer,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Popup: node_modules_vux_src_components_popup,
    Loading: vux_src_components_loading,
    Actionsheet: vux_src_components_actionsheet,
    myHeader: src_components_myHeader
  },
  methods: extends_default()({
    handleClosePop: function handleClosePop() {
      this.showPop = false;
    },
    toSonRotate: function toSonRotate() {
      this.$store.dispatch("setRotate", false);
    },
    handleMenuClick: function handleMenuClick() {
      this.showMenu = !this.showMenu;
    },
    changeLocale: function changeLocale(locale) {
      this.$i18n.set(locale);
      this.$locale.set(locale);
    }
  }, Object(vuex_esm["b" /* mapActions */])(["updateDemoPosition"])),
  mounted: function mounted() {
    this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
    this.$store.dispatch("setLang", this.$locale.get());
    window.addEventListener("resize", function () {
      this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    this.box && this.box.removeEventListener("scroll", this.handler, false);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    route: function route(state) {
      return state.route;
    },

    deviceready: function deviceready(state) {
      return state.app.deviceready;
    },
    demoTop: function demoTop(state) {
      return state.vux.demoScrollTop;
    },
    isLoading: function isLoading(state) {
      return state.vux.isLoading;
    },
    direction: function direction(state) {
      return state.vux.direction;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    isShowHeader: function isShowHeader(state) {
      return state.app.isShowHeader;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  }), {
    isShowBar: function isShowBar() {
      if (this.entryUrl.indexOf("hide-tab-bar") > -1) {
        return false;
      }
      return true;
    },
    isShowNav: function isShowNav() {
      if (this.entryUrl.indexOf("hide-nav") > -1) {
        return false;
      }
      return true;
    },
    headerTransition: function headerTransition() {
      if (!this.direction) return "";
      return this.direction === "forward" ? "vux-header-fade-in-right" : "vux-header-fade-in-left";
    },
    viewTransition: function viewTransition() {
      if (!this.direction) return "";
      return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
    }
  }),
  data: function data() {
    return {
      isIE: utils.isIE(),
      entryUrl: document.location.href,
      showMenu: false,
      op88888: String(window.location.href).toLowerCase().indexOf("op88888") > -1,
      showPop: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


(function rotate() {
  var orientation = window.orientation;
  var pd = null;
  function createPd() {
    if (document.getElementById("preventTran") === null) {
      var imgData = "data:image/png;base64,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";
      pd = document.createElement("div");
      pd.setAttribute("id", "preventTran");
      pd.style.position = "fixed";
      pd.style.left = "0";
      pd.style.top = "0";
      pd.style.width = "100%";
      pd.style.height = "100%";
      pd.style.overflow = "hidden";
      pd.style.backgroundColor = "#03447C";
      pd.style.textAlign = "center";
      pd.style.zIndex = "99999";
      document.getElementsByTagName("body")[0].appendChild(pd);
      var img = document.createElement("img");
      img.src = imgData;
      pd.appendChild(img);
      img.style.margin = "60px auto 30px";
      var br = document.createElement("br");
      var p = document.createElement("p");
      p.style.width = "100%";
      p.style.height = "auto";
      p.style.fontSize = "22px";
      p.style.color = "#FFF";
      p.style.lineHeight = "34px";
      p.style.textAlign = "center";
      p.innerHTML = "为了体验更好的视觉效果";
      p.appendChild(br);
      p.innerHTML += "请竖屏观看/操作";
      pd.appendChild(p);
    }
  }
  if (orientation == 90 || orientation == -90) {
    if (pd == null && document.getElementById("preventTran") === null) createPd();
    document.getElementById("preventTran").style.display = "block";
  }
  window.onorientationchange = function () {
    if (pd == null && document.getElementById("preventTran") == null) createPd();
    document.getElementById("preventTran").style.display = "none";
    rotate();
  };
})();



















/* harmony default export */ var selectortype_script_index_0_src_App = ({
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },

  components: {
    Radio: node_modules_vux_src_components_radio,
    Group: group["a" /* default */],
    Cell: vux_src_components_cell,
    Badge: vux_src_components_badge,
    Drawer: vux_src_components_drawer,
    ButtonTab: src_components_button_tab_button_tab,
    ButtonTabItem: src_components_button_tab_button_tab_item,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    Tabbar: src_components_tabbar_tabbar,
    TabbarItem: src_components_tabbar_tabbar_item,
    Popup: node_modules_vux_src_components_popup,
    Loading: vux_src_components_loading,
    Actionsheet: vux_src_components_actionsheet,
    myHeader: src_components_myHeader
  },
  methods: extends_default()({
    handleClosePop: function handleClosePop() {
      this.showPop = false;
    },
    toSonRotate: function toSonRotate() {
      this.$store.dispatch("setRotate", false);
    },
    handleMenuClick: function handleMenuClick() {
      this.showMenu = !this.showMenu;
    },
    changeLocale: function changeLocale(locale) {
      this.$i18n.set(locale);
      this.$locale.set(locale);
    }
  }, Object(vuex_esm["b" /* mapActions */])(["updateDemoPosition"])),
  mounted: function mounted() {
    this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
    this.$store.dispatch("setLang", this.$locale.get());
    window.addEventListener("resize", function () {
      this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    this.box && this.box.removeEventListener("scroll", this.handler, false);
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapState */])({
    route: function route(state) {
      return state.route;
    },

    deviceready: function deviceready(state) {
      return state.app.deviceready;
    },
    demoTop: function demoTop(state) {
      return state.vux.demoScrollTop;
    },
    isLoading: function isLoading(state) {
      return state.vux.isLoading;
    },
    direction: function direction(state) {
      return state.vux.direction;
    },
    isMobile: function isMobile(state) {
      return state.app.isMobile;
    },
    isShowHeader: function isShowHeader(state) {
      return state.app.isShowHeader;
    },
    lang: function lang(state) {
      return state.app.lang;
    }
  }), {
    isShowBar: function isShowBar() {
      if (this.entryUrl.indexOf("hide-tab-bar") > -1) {
        return false;
      }
      return true;
    },
    isShowNav: function isShowNav() {
      if (this.entryUrl.indexOf("hide-nav") > -1) {
        return false;
      }
      return true;
    },
    headerTransition: function headerTransition() {
      if (!this.direction) return "";
      return this.direction === "forward" ? "vux-header-fade-in-right" : "vux-header-fade-in-left";
    },
    viewTransition: function viewTransition() {
      if (!this.direction) return "";
      return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
    }
  }),
  data: function data() {
    return {
      isIE: utils.isIE(),
      entryUrl: document.location.href,
      showMenu: false,
      op88888: String(window.location.href).toLowerCase().indexOf("op88888") > -1,
      showPop: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e17012c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'en':_vm.lang=='en','ie':_vm.isIE},attrs:{"id":"app"}},[_c('div',{staticStyle:{"height":"100%"}},[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticClass:"m-nav-menu",attrs:{"position":"left"},on:{"on-hide":_vm.toSonRotate},model:{value:(_vm.showMenu),callback:function ($$v) {_vm.showMenu=$$v},expression:"showMenu"}},[_c('ul',[_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#element'),expression:"'#element'"}],attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('menu.home')))])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#ourAdvantage'),expression:"'#ourAdvantage'"}],attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('menu.ourAdvantage')))])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#aboutUs'),expression:"'#aboutUs'"}],attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('menu.aboutUs')))])]),_vm._v(" "),(!_vm.op88888)?_c('li',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#linkUs'),expression:"'#linkUs'"}],attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$t('menu.linkUs')))])]):_vm._e()])])],1),_vm._v(" "),(_vm.isShowHeader)?_c('my-header',{attrs:{"op88888":_vm.op88888,"rotateVal":"rotate"},on:{"menuClick":_vm.handleMenuClick}}):_vm._e(),_vm._v(" "),_c('view-box',{ref:"viewBox"},[_c('transition',{attrs:{"name":_vm.viewTransition,"css":!!_vm.direction},on:{"after-enter":function($event){_vm.$vux.bus && _vm.$vux.bus.$emit('vux:after-view-enter')}}},[_c('router-view',{staticClass:"router-view",attrs:{"op88888":_vm.op88888}})],1)],1),_vm._v(" "),(_vm.showPop)?_c('div',{staticClass:"pop-box"},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"pop-box-bg"}),_vm._v(" "),_c('div',{staticClass:"pop-box-close",on:{"click":_vm.handleClosePop}})])]):_vm._e()],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("3SJ+")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/main.js














utils.refreshRem();
window.addEventListener('resize', function () {
  utils.refreshRem();
}, false);

var VueScrollTo = __webpack_require__("bm7V");







__webpack_require__("hKoQ").polyfill();

var jumpReload = false;

vue_esm["a" /* default */].prototype.$md5 = md5_default.a;
vue_esm["a" /* default */].prototype.$url = 'https://api.gcpadi.com';

vue_esm["a" /* default */].use(vue_cookie_default.a);
vue_esm["a" /* default */].use(locale["a" /* default */]);
vue_esm["a" /* default */].use(bus["a" /* default */]);
vue_esm["a" /* default */].use(toast["a" /* default */]);
vue_esm["a" /* default */].use(vuex_i18n_es["a" /* default */].plugin, src_store);
vue_esm["a" /* default */].use(datetime["a" /* default */]);
vue_esm["a" /* default */].use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -46,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

window.$vue = vue_esm["a" /* default */];
var finalLocales = {
  'en': en,
  'zh-CN': zh,
  'taiwan': taiwan
};
for (var i in finalLocales) {
  vue_esm["a" /* default */].i18n.add(i, finalLocales[i]);
}

var nowLocale = vue_esm["a" /* default */].locale.get();
if (/en/.test(nowLocale)) {
  vue_esm["a" /* default */].i18n.set('en');
} else if (/taiwan/.test(nowLocale)) {
  vue_esm["a" /* default */].i18n.set('taiwan');
} else {
  vue_esm["a" /* default */].i18n.set('zh-CN');
}

vue_esm["a" /* default */].config.productionTip = false;

var shouldUseTransition = !/transition=none/.test(location.href);

src_store.registerModule('vux', {
  state: {
    isLoading: false,
    direction: shouldUseTransition ? 'forward' : ''
  },
  mutations: {
    updateLoadingStatus: function updateLoadingStatus(state, payload) {
      state.isLoading = payload.isLoading;
    },
    updateDirection: function updateDirection(state, payload) {
      if (!shouldUseTransition) {
        return;
      }
      state.direction = payload.direction;
    }
  },
  actions: {}
});

router.afterEach(function () {

  src_store.commit('updateLoadingStatus', {
    isLoading: false
  });
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  store: src_store,
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "P41L":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/errenmj_small.434594e.png";

/***/ }),

/***/ "PgbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RZzK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bairenbaijiale.d3d5bfa.jpg";

/***/ }),

/***/ "Rtzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SFn8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1048.cd0f56f.png";

/***/ }),

/***/ "SUAD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sangong.a8200c7.jpg";

/***/ }),

/***/ "Sj6I":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1049.40ef36d.png";

/***/ }),

/***/ "TlwD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.1c16b37.jpg";

/***/ }),

/***/ "UHeo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shuiguopaidui.045b481.jpg";

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: icon_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("1VxO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 6 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("tbir")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (datetime_Component.exports);


/***/ }),

/***/ "VSyL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/laohuji.4ab6b9a.jpg";

/***/ }),

/***/ "WX8O":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/luopan_pc_game.e3ad10c.mp4";

/***/ }),

/***/ "WbPu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/baijiale_pc_game.25944fd.mp4";

/***/ }),

/***/ "Wjjm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/taimajiang.dd8f161.jpg";

/***/ }),

/***/ "Wjw9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/buyu_pc_game.1413215.mp4";

/***/ }),

/***/ "X1gC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doudizhu1.969b918.png";

/***/ }),

/***/ "XLW9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.0380148.jpg";

/***/ }),

/***/ "Xe6N":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Niu-niu_open4.3a669bf.jpg";

/***/ }),

/***/ "XpBD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1049.a15ca55.png";

/***/ }),

/***/ "YIAk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doudizhujishu.0caddb7.png";

/***/ }),

/***/ "YP1G":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guangdongmajiang.dca52b6.jpg";

/***/ }),

/***/ "YXis":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/taiqiudashi.9bd738c.jpg";

/***/ }),

/***/ "YYzr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/20.f495bc9.jpg";

/***/ }),

/***/ "Z1XC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.7e73b4c.jpg";

/***/ }),

/***/ "Z8hn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/21.dcc7948.jpg";

/***/ }),

/***/ "ZFFU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mermaidFishing-s.37adcf5.png";

/***/ }),

/***/ "ZLAY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZxhC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.8bb9917.jpg";

/***/ }),

/***/ "Zzmh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/27.d418b8b.jpg";

/***/ }),

/***/ "a4fN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhajinhua_m_game.2317b66.mp4";

/***/ }),

/***/ "aLG7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dzpk_qzc.53f70df.png";

/***/ }),

/***/ "aekv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/feiqinzoushou.2e15a29.jpg";

/***/ }),

/***/ "bDQm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/baisheng_1280X720.6f6463c.mp4";

/***/ }),

/***/ "cSTo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3dzhajinhua.90b3815.png";

/***/ }),

/***/ "d1S8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dzpk_qzc_banner.3b53e8f.png";

/***/ }),

/***/ "dVNw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.0049681.jpg";

/***/ }),

/***/ "evfb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/15.639faa6.jpg";

/***/ }),

/***/ "gXWh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h+oE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guojimajiang.78c3f2c.jpg";

/***/ }),

/***/ "hH10":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ksznn.acc1242.png";

/***/ }),

/***/ "hxFk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1048.1f160ce.png";

/***/ }),

/***/ "i+fE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iBgm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pirateFishing-s.7dbc974.png";

/***/ }),

/***/ "iyji":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xuezhanmajiang.afdba80.jpg";

/***/ }),

/***/ "j62E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jAZE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tongbituitongzi.6d95226.jpg";

/***/ }),

/***/ "jZMx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/baisheng_640x360.6c75f36.mp4";

/***/ }),

/***/ "jylW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/14.02e16cd.jpg";

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lleX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shidianban.c5bc223.jpg";

/***/ }),

/***/ "m4ou":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mH5o":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "mUw0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nB2o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sanzhangpuke.665493e.jpg";

/***/ }),

/***/ "nFl9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/doudizhu.168d222.jpg";

/***/ }),

/***/ "oMHB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/24.288c0bf.jpg";

/***/ }),

/***/ "oR1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obpj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/10.e4d47a7.jpg";

/***/ }),

/***/ "pPjQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qznn_3d_s.01c75cd.png";

/***/ }),

/***/ "ps3f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ksznn_3d_s.6c16bae.png";

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Rtzy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("8vzP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s6er":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/luopan_m_game.875de27.mp4";

/***/ }),

/***/ "sKtX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/25.fc9d623.jpg";

/***/ }),

/***/ "t+oN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t1li":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/paohuzi.3460e85.jpg";

/***/ }),

/***/ "tH2/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tbN9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jialebipuke.96cbec8.jpg";

/***/ }),

/***/ "tbir":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWI9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baisheng_640x360.mp4.6b61438.gif";

/***/ }),

/***/ "upOt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/18.ff53947.jpg";

/***/ }),

/***/ "vDf8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_1027.c9a81b6.png";

/***/ }),

/***/ "whnJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mermaidFishing.d309eb8.png";

/***/ }),

/***/ "yBDv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yF/s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.06e5aa0.jpg";

/***/ }),

/***/ "ywh3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/xingyunwu.fea9f38.jpg";

/***/ }),

/***/ "yxlL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yyZe":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "zLiC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/guandao.82246ad.jpg";

/***/ }),

/***/ "zYMp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.9be70ac.jpg";

/***/ }),

/***/ "zmfZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner-RED&BLACK.d06a9b4.jpg";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.391193c2ed7edbb8307d.js